const translationsSpa = {
  commonGround: {
    1: [
      `TERRENO COMÚN`,
      `EL AGUA, TIERRA, Y AIRE QUE COMPARTIMOS`,

      `MOLLY BANG
`,
    ],
    2: [
      `
            OJALÁ TOMEMOS NUESTRAS DECISIONES
                
            PENSANDO EN LA SÉPTIMA GENERACIÓN
            `,
    ],
    3: [
      `Hace mucho tiempo, se construyó una aldea alrededor de un área comunal.`,
    ],
    4: [
      `
            El área comunal era “terreno común”
            que pertenecía a todos los aldeanos.`,

      `Todos los aldeanos podían traer a sus ovejas
            a pastar en el área comunal.
            `,
    ],
    5: [
      `
            Pero había un problema.	`,
      `Un aldeano que tenía muchas ovejas usó
            más del área comunal que un aldeano que
            tenía pocas ovejas, o una, o ninguna.
            `,
    ],
    6: [
      `
            Y como el pasto del área comunal era gratis, las
            personas ponían cuantas ovejas podían a pastar ahí.
            Pronto había demasiadas ovejas.	`,
      `No había suficiente pasto para todas ellas.
            Esto no era bueno para el área comunal, o para las ovejas, o para los aldeanos. Así que las personas
            hicieron una de dos cosas.
            `,
    ],
    7: [
      `
            Algunas personas se quedaron en la aldea, pero 
            hicieron un plan juntas. Acordaron
            que mantendrían el área comunal verde y frondosa,
            y que la compartirían de mejor manera.`,

      `Cada persona solamente podía poner una oveja
            en el área común.
            Todos tenían que seguir esta regla.
            Otras personas eligieron irse de la aldea.
            `,
    ],
    8: [
      `
            Siempre había algún otro lugar a donde ir.`,

      `Hoy el mundo es muy similar a esa aldea.
            Ahora nuestras áreas comunales son nuestros `,

      `parques, reservas y recursos naturales, y las aguas 
            y el aire de todo el mundo.
            Hoy tenemos casi el mismo problema que
            tuvieron los aldeanos.
            `,
    ],
    9: [
      `
            Hoy cada pescador trata de pescar cuantos 
            peces puede del mar comunal.`,

      `De esta manera, el pescador tiene más peces que vender—a corto plazo.
            `,
    ],
    10: [
      `
            Pero pronto hay menos y menos peces.`,

      `Esto no es bueno para los peces, para el mar, o para las personas.
            `,
    ],
    11: [
      `
            Hoy cada compañía maderera quiere cortar cuantos
            árboles pueda, para venderlos para madera, papel, y combustible.`,

      `Mientras más arboles corta la compañía maderera,
            más dinero gana —a corto plazo.
            `,
    ],
    12: [
      `
            Pero después de cortar tantos árboles,
            hay menos y menos bosques.	`,
      `Esto no es bueno para los árboles, o para
            las criaturas del bosque, o el suelo del bosque.
            `,
    ],
    13: [
      `
            Usamos nuestro petróleo, gas, y carbón comunal para calentar nuestras casas y echar a andar nuestros autos. Las compañías los usan para hacer plásticos y otros químicos.`,

      `De esta manera, podemos estar calientitos, viajar largas distancias, y visitar tiendas llenas de cosas increíbles que comprar—a corto plazo.
            `,
    ],
    14: [`Pero un día, estos combustibles fósiles se acabarán.`],
    15: [
      `
            Todos necesitamos agua para beber, cocinar, y lavar.
            Las granjas necesitan agua para las cosechas y el ganado. Y los negocios necesitan agua para enfriar máquinas y limpiar desechos.`,

      `Así que bombeamos tanta de nuestra agua comunal como podemos.
            Esto funciona bastante bien—
            a corto plazo.
            `,
    ],
    16: [
      `
            Pero al pasar el tiempo, los pozos se secan, y los desperdicios contaminan el agua.
            No hay suficiente agua limpia para todas las personas, las granjas, y los negocios.`,

      `El agua fresca, los combustibles fósiles, bosques, peces—uno por uno, estamos destruyendo los recursos naturales que sustentan nuestras vidas.
            `,
    ],
    17: [
      `Entonces, aquí esta nuestra pregunta común:`,

      `¿Si nuestro país, nuestras compañías, y cada uno de nosotros se beneficia más a corto plazo por usar cuantos recursos naturales podamos, entonces que nos detendrá de destruir todo nuestro mundo—nuestro terreno común?`,

      `Necesitamos contestar esta pregunta JUNTOS,
            porque hoy somos diferentes a esos antiguos
            aldeanos de una manera muy importante…
            `,
    ],
    18: [`Hoy no tenemos otro lugar a donde ir.`],
  },

  myLight: {
    1: [
      `MI LUZ`,
      `Por Molly Bang
                `,
    ],
    2: [
      `Cuando ves las luces de la ciudad de noche,
            parecen estrellas que han caído del cielo.`,

      `Esas luces sí SON luz de estrella—mi luz.
            `,
    ],
    3: [
      `
            Yo soy tu sol, una estrella dorada.
            
            Tu ves mi brillo como luz.
                
            Cada día yo caliento 
            tu tierra y tu agua.
            
            Pequeñas gotas de agua
            tibia suben y
            forman nubes.
            `,
    ],
    4: [
      `
            Las nubes se enfrían.`,

      `Mi energía cae como lluvia.	`,

      `El agua corre
            de arroyos a
            ríos, llevando 
            mi energía
            hacia abajo,
            abajo,
            abajo.
            `,
    ],
    5: [
      `¡Una presa!
            Ustedes los humanos detienen la corriente.
            Mi energía es atrapada.`,

      `¡Whish!
            Algo de agua se dispara hacia abajo
            por túneles hacia enormes turbinas.`,

      `¡Whush!
            El agua gira las 
            turbinas una y otra vez.
            Gira mi energía hacia
            generadores que
            crean electricidad.`,

      `Ahora mi energía está
            en la electricidad. Se va
            corriendo por alambres de cobre.
            `,
    ],
    6: [
      `¡Los alambres zumban!`,

      `La electricidad corre,
            pulsando, pulsando, pulsando
            mi energía hacia
            tus pueblos y
            tus ciudades.
            `,
    ],
    7: [
      `Cada día brillo sobre la tierra y
            caliento el aire. El aire tibio sube.
            El aire más fresco entra y forma el viento.`,

      `¡Swish! ¡Swush!
            El viento empuja las aspas
            de las turbinas dando vuelta y vuelta,
            girando mi energía hacia generadores
            que crean electricidad.`,

      `La electricidad corre por
            alambres de cobre y sale hacia
            tus pueblos y ciudades.
            `,
    ],
    8: [
      `Las plantas verdes atrapan mi luz
            y usan mi energía para ayudar a
            formar hojas y tallos.
            `,
    ],
    9: [
      `	
            Mi energía
            forma cada arbusto
            y flor, caña y cacto, fruta y árbol.
            Mi luz alimenta a todas las plantas de la tierra.`,

      `Algunas de las plantas son comidas. Mi energía fluye
            a todo lo que las come.
            `,
    ],
    10: [
      `Otras plantas mueren y son enterradas.
            Algunas fueron enterradas hace 
            millones y millones de años y se 
            convirtieron en carbón.
            Entonces mi energía se quedó
            muy profundo bajo la tierra
            encerrada en el carbón.
            `,
    ],
    11: [
      `¡Cronch! ¡Rarr!
            Ahora ustedes los humanos excavan el carbón.
            Lo sacan y lo queman.`,

      `El fuego calienta al agua convirtiéndola en vapor.
            ¡Whush!
            El vapor se dispara contra
            turbinas gigantes, que giran
            una y otra vez. Estas mandan
            mi energía a generadores,
            que crean electricidad.`,

      `De centrales eléctricas de carbón,
            la electricidad corre por alambres
            de cobre, hacia tus
            pueblos y ciudades.
            `,
    ],
    12: [
      `
            Mi luz cae en celdas solares
            y carga sus electrones.`,

      `Sin turbinas, ni generadores--	
            La electricidad corre por las celdas,
            las cuales la vierten a alambres de cobre.`,

      `La electricidad fluye al edifico debajo de las celdas.
            `,
    ],
    13: [
      `
            Cuando cae la noche, tu enciendes la luz.`,

      `Viniendo de viento y agua corrientes,
            de carbón encendido, y de silenciosas celdas solares,
            tu dejas que mi energía entre a tu habitación.`,

      `La electricidad ilumina la noche.`,

      `Dentro de un foco,
            un alambre quema ardiente.
            Brilla.`,

      `Dentro de un tubo fluorescente,
            se activa gas.
            Brilla.
            `,
    ],
    14: [
      `Cuando enciendes las luces de noche,
            parecen estrellas que han caído a la tierra.`,

      `Esas luces son energía de parte de mí, tu estrella dorada,
            energía atrapada y transformada por tu tierra,
            y por ustedes.`,

      `Por un momento,
            mi luz ilumina tus pueblos y ciudades.
            `,
    ],
    15: [
      `
            Y luego, como la luz de estrella de donde provino,
            se desvanece de nuevo en el espacio.
            `,
    ],
  },

  livingSunlight: {
    1: [
      `LUZ VIVIENTE`,
      `CÓMO LAS PLANTAS TRAEN VIDA A LA TIERRA`,
      `POR Molly Bang Y Penny Chisholm
                `,
    ],
    2: [
      `Escúchame.
            Has lo siguiente:
            Pon tu mano sobre tu corazón, y siente.
            Siente tu corazón palpitar, palpitar, y palpitar.
            Siente lo tibio que estás.`,

      `Esa es mi luz, que vive dentro de ti.
            `,
    ],
    3: [
      `Yo soy tu sol, tu estrella dorada.`,

      `Yo quemo.`,

      `Mi energía luminosa explota en todas las direcciones.`,

      `La mayoría se desvanece en el espacio infinito.`,

      `Pero una muy diminuta parte de mi luz
            cae sobre tu pequeño planeta,
            La Tierra.
            `,
    ],
    4: [
      `
            Yo caliento tu tierra`,

      `y tus mares,`,

      `derrito tus glaciales,`,

      `creo tus vientos.`,

      `Yo hago todo esto.`,

      `Pero hago mucho, mucho más…
            
            `,
    ],
    5: [
      `
            Mi luz se convierte en energía
            para toda la vida en la Tierra.`,

      `Todos los seres vivientes—
            incluyéndote a TÍ—
            pulsan con mi luz
            y la mantienen circulando
            alrededor, alrededor de la Tierra.	`,

      `¿Cómo hacen esto
            los seres vivos?`,

      `¿Cuál es tu secreto?
            `,
    ],
    6: [
      `
            Tu secreto comienza en las plantas--
            las plantas verdes.`,

      `Las plantas absorben agua—H2O--de la Tierra. Durante el día,
            las plantas verdes atrapan mi energía con su clorofila.`,

      `Entonces…`,

      `¡ZAS!`,

      `Las plantas usan mi energía para separar el agua—
            separar el H2O en H y O2, hidrógeno y oxígeno.`,

      `Pero al separar el agua,
            las plantas atrapan mi energía en paquetitos.
            `,
    ],
    7: [
      `
            Mientras tanto, las plantas están respirando.
            (¡Sí, las plantas respiran!)`,

      `Exhalan el oxígeno
            que separaron del agua
            é inhalan
            dióxido de carbono—CO2—
            del aire.`,

      `Ahora las plantas usan los paquetitos de mi energía
            y el dióxido de carbono del aire para formar
            CHUNKA-CHUNKA-CHUNKA…
            `,
    ],
    8: [
      `
            …¡azúcar! Y con esta azúcar, las plantas
            forman todas sus partes. Todas las hojas y tallos
            y jugos, todas las semillas y frutos y 
            flores de todas las plantas de la Tierra, son
            formadas de azúcar hecha del aire y
            el agua usando mi energía luminosa.`,

      `Esto es fotosíntesis—
            crear vida usando luz solar, mi luz.`,

      `Este es mi regalo de energía para ti.
            `,
    ],
    9: [
      `
            ¡Pero espera! ¡Tú no eres verde!`,

      `Tú no tienes hojas, ni clorofila.`,

      `Tú no puedes atrapar mi luz. Ni tus padres tampoco,
            o tus amigos, tus maestros,
            ni ningún reptil, insecto, pez,
            ave, o mamífero en 
            todo el mundo.`,

      `Así que…`,

      `¿Cómo obtienes TÚ mi energía?`,

      `¿Lo sabes?
            `,
    ],
    10: [
      `Sí, tu comes plantas. Cuando comes sus hojas y tallos 
            y jugos, cuando te comes sus semillas y frutos y flores,
            te comes mi energía, mi luz viviente.
            `,
    ],
    11: [
      `Y las plantas hacen aún más que darte comida.`,

      `¿Recuerdas cómo, en la fotosíntesis,
            las plantas verdes exhalan oxígeno?`,

      `¿Qué pasa con ese oxígeno?`,

      `Llena el aire.`,

      `Todo el oxígeno que ustedes los seres vivos respiran
            viene de las plantas verdes.
            `,
    ],
    12: [
      `
            Inhala.
            
            Siente el oxígeno correr por tu nariz, tu boca—
            por todo tu cuerpo.
            El oxígeno es un regalo de las plantas para ti. Tu cuerpo usa oxígeno
            junto con las azúcares de las plantas.
            Tu cuerpo las quema, lentamente, para hacer la energía
            que usas para moverte, crecer y vivir.	
            Sin plantas,
            no tendrías oxígeno.`,

      `Sin plantas,
            no tendrías comida.`,

      `Sin plantas,
            no podrías vivir.`,

      `Sin plantas,
            no habría vida en la Tierra.
            `,
    ],
    13: [
      `
            Ahora exhala.
            
            No es oxígeno lo que exhalas.`,

      `Cuando usas las azúcares de las plantas para energía,
            las azúcares se deshacen dentro de tu cuerpo,
            convirtiéndose de nuevo en agua y dióxido de carbono.`,

      `Así que ahora exhalas dióxido de carbono
            y las plantas lo inhalan.`,

      `Lo usarán para formar más azúcar—
            comida para sí mismas y para otros seres vivos.
            `,
    ],
    14: [
      `¿Lo ves?
            La vida sigue circulando alrededor
            y alrededor de tu planeta
            Tierra, por medio de la fotosíntesis,
            y por medio de ustedes.`,

      `Compartes vida con
            Todos los seres vivos.
            `,
    ],
    15: [
      `Pon tu mano sobre tu corazón y siente.`,

      `Siente mi luz dentro de ti.`,

      `Tú guardas mi luz y la haces vivir.`,

      `Tú eres luz viviente.
            `,
    ],
  },

  buriedSunlight: {
    1: [
      `LUZ ENTERRADO:`,
      `CÓMO LOS COMBUSTIBLES FÓSILES HAN CAMBIADO A LA TIERRA`,
      `Por Molly Bang y Penny Chisholm`,
    ],
    2: [
      `YO SOY TU SOL, TU ESTRELLA DORADA. Aún a 93 millones de millas de distancia, yo caliento tu tierra, tus mares, tu aire y alejo a la oscuridad de tus días.`,
      `Mi energía da luz y vida a tu pequeño planeta Tierra.`,
    ],
    3: [
      `Sí, los seres vivos—incluyéndote a TI— Necesitan energía para vivir y crecer.`,
      `Pero también usas energía para calentar tu casa, para cocinar tu comida,`,
      `para mover tus carros y trenes y barcos, para usar tus computadoras y máquinas.`,
      `¿De dónde viene esa energía?`,
    ],
    4: [
      `La mayoría viene del carbón el petróleo y el gas; llamados combustibles fósiles.`,
      `¿Qué los hace “FÓSILES”?`,
      `Al igual que los dinosaurios, son vida antigua enterrada profundamente bajo la tierra. Pero los fósiles combustibles son PLANTAS antiguas. Estas capturaron luz que brillé sobre la Tierra hace millones de años.`,
      `Todo este tiempo, estas plantas fósiles han mantenido mi energía solar atrapada dentro de sí.`,
      `Cuando se queman combustibles fósiles, se libera la energía atrapada dentro de esas plantas antiguas y se convierte en luz y calor.`,
      `¿Pero cómo capturaron y atraparon dentro de sí mi energía solar esas plantas?`,
    ],
    5: [
      `¡POR MEDIO DE LA FOTOSÍNTESIS!`,
      `Esto es lo que sucede: las plantas verdes en todos lados atrapan mi luz y la usan para extraer dióxido de carbono (CO2) del aire. Estas usan mi energía solar para construir cadenas de carbono—¡azúcar! — que forman sus hojas, tallos, y fruta. Y a medida que fotosintetizan, estas mismas plantas verdes liberan oxígeno (O2) al aire—el aire que tu respiras.`,
      `¿QUÉ SUCEDE ENTONCES?`,
    ],
    6: [
      `¡TÚ te devoras
            las plantas!
            ¡Te comes sus
            cadenas de
            carbono!`,

      `Inhalas el oxígeno
            que las plantas exhalaron.
            Lo usas para romper las cadenas
            y tomar su energía, para TÚ
            poderte mover, vivir y crecer.`,

      `Exhalas las partes 
            rotas de las cadenas
            como dióxido de carbono, CO2.`,

      `Este es el
            CICLO
            DE LA
            VIDA.`,
    ],
    7: [
      `Este Ciclo de la Vida
            está casi en
            equilibrio perfecto.`,

      `Todas las plantas 
            juntas hacen una
            diminuta cantidad de
            cadenas de carbono
            más de las que todos
            los animales y las
            bacterias comen.`,

      `Y las plantas
            exhalan una
            diminuta cantidad
            de oxígeno más
            de lo que los animales y
            las bacterias inhalan.`,

      `La diferencia no es mucha,
            pero a través DE MILLONES
            Y MILLONES DE
            AÑOS, una cantidad
            diminuta cada año
            puede hacer una 
            diferencia ENORME!`,

      `De hecho,
            estas diminutas 
            diferencias te dan 
            dos de los 
            tesoros más grandes
            de la Tierra:
            todo el oxígeno
            que respiras, y los
            combustibles fósiles.`,

      `Esto es lo que sucedió.`,
    ],
    8: [
      `
            Hace billones de años, mucho antes de que los dinosaurios vagaran por la Tierra, no había vida 
            en la tierra.`,

      `NO HABÍA OXÍGENO EN EL AIRE.
            NADA.`,

      `En aquel entonces, la única vida en la Tierra eran las 
            diminutas bacterias flotando en los mares y los
            diminutos animales marinos que las comían. 
            ¡Eventualmente, algunas de esas diminutas bacterias 
            evolucionaron hasta convertirse en diminutas
            plantas verdes!`,

      `Atraparon mi luz, hicieron cadenas de carbono
            —azúcar, y exhalaron oxígeno hacia el mar. 
            Cada año, sacaron un poco más oxigeno del que 
            podían respirar los diminutos animalitos.`,

      `Así que durante
            MILLONES Y MILLONES DE AÑOS,
            el oxígeno extra burbujeaba hacia el agua
            y hacia arriba…hasta que el agua y el aire
            estaban llenos de oxígeno.`,

      `Cada año, las diminutas plantas hacían unas 
            cuantas cadenas de carbono más de las que 
            los diminutos animales marinos podían comer.`,

      `Así que durante MILLONES Y MILLONES DE
            AÑOS, las cadenas de carbono extras se 
            acumularon en el suelo marino.
            `,
    ],
    9: [
      `
            Durante MILLONES Y MILLONES DE AÑOS MÁS, fueron
            evolucionando animales y plantas más grandes que
            se trasladaron a la tierra. Y al igual que las diminutas plantas
            del mar, las plantas terrestres hicieron más cadenas de carbono 
            de las que podían comer los animales y las bacterias terrestres.
            Cada año, esas cadenas de carbono no consumidas—plantas muertas—
            se fueron acumulando. Al pasar aún más MILLONES Y MILLONES
            DE AÑOS, todas esas plantas muertas (con mi energía atrapada dentro de ellas)
            fueron enterradas bajo capas de tierra, en la tierra y en el fondo del mar.`,

      `Enterradas más y más 
                      Profundo, fueron
                                APLASTADAS`,

      `y transformadas en…
                      petróleo y carbón y gas:`,

      `COMBUSTIBLES FOSILES—
            mi antigua
            luz enterrada.`,
    ],
    10: [
      `Estos combustibles fósiles estuvieron en las profundidades de la Tierra por 
            millones de años, mientras que evolucionaban nuevas y diferentes criaturas.`,

      `Algunas plantas y animales se extinguieron, y evolucionaron
            Nuevos, pero el Ciclo de la Vida continuó girando.`,

      `Eventualmente—sólo hace unos cientos de miles de años—`,

      `Ustedes los humanos evolucionaron y se esparcieron por toda la Tierra.
            Encendieron fogatas para calentarse y cocinar su comida.
                      Y un día, descubrieron…
            `,
    ],
    11: [
      ` 
            ¡Combustibles fósiles!
            ¡¡¡Mi LUZ
            ENTERRADA!!!`,

      `Rápidamente, ustedes 
            comenzaron a quemar esos 
            combustibles fósiles
            —el carbón, el petróleo y 
            el gas que tomaron millones 
            y millones de años para que
             el Ciclo de la Vida los hiciera.`,

      `Ahora ustedes usan mi antigua
            energía solar para alimentar su mundo.`,

      `Cuando queman combustibles fósiles,
            rompen sus cadenas de carbono,
            extraen oxígeno del aire, y
            emiten dióxido de carbono, CO2.
            `,
    ],
    12: [
      `
            Cada año, a medida que se queman más combustibles
            fósiles, más CO2 sube al aire de la Tierra.
            Los árboles, plantas y océanos extraen lo
            más que pueden, pero no es suficiente
            para evitar que el CO2 se acumule en el cielo.`,

      `Tus científicos lo están midiendo.`,

      `Ellos ven que el CO2 está aumentando más y más rápido. Y ustedes los humanos también están cortando bosques y quemándolos para
            despejar la tierra, para sembrar comida,
            enviando aún más CO2 al aire.`,

      `Algunas personas dicen “¿Y QUÉ?”.
            `,
    ],
    13: [
      `PUES ESTO: El CO2 es parte de una “capa” de gases alrededor de la Tierra.
            Mi luz solar pasa a través de la capa y calienta a la Tierra,
            pero mucho de ese calor rebota y se regresa al espacio.
            Ciertos gases, como el CO2, atrapan el calor y lo detienen.
            Esto ayuda a controlar la temperatura de la Tierra.`,

      `Cuando estos gases se pierden de la capa, la Tierra se enfría.`,

      `Cuando aumentan en la capa, la Tierra se calienta.`,

      `Quemar combustibles fósiles y quemar sus bosques
            mete más CO2 a la capa de la Tierra cada año.
            Atrapa más calor y calienta la tierra y los mares.
            `,
    ],
    14: [
      `Tu Tierra ha comenzado
            a sentir esos cambios:
            Se están derritiendo algo
            del hielo Ártico y algunos
            glaciares.`,

      `Los mares se calientan,
            y algunos están comenzando 
            a cubrir la tierra.`,

      `El calentamiento causa
            tormentas más feroces, y
            sequias e inundaciones.`,

      `Por toda la Tierra
            el clima es ligeramente
            diferente de cómo lo
            fue en el pasado reciente. `,

      `En el futuro los
            cambios probablemente
            serán más severos…
            `,
    ],
    15: [
      `
            Algunas personas aún preguntan, “¿Y QUÉ?”
            ¡La Tierra ha cambiado MUCHO en los billones de años
            desde que nació! ¡Ha sido MUCHO más caliente,
            y MUCHO más fría, de lo que es ahora!
            “¿Por qué no quemar combustibles fósiles?”`,

      `Esas personas tienen razón en PARTE.`,

      `Yo, tu sol, he visto a tu planeta
            calentarse y enfriarse muchas veces.`,

      `La Tierra ha sido tan fría que el hielo cubría
            las playas en donde nadas hoy en día.
            La Tierra ha sido tan caliente que antes crecían
            palmeras en donde ahora cae nieve.`,

      `Frío y calor, frío y calor, tu planeta pasa
            por estos cambios y siempre lo hará.`,

      `AÚN SIN HUMANOS.`,
    ],
    16: [
      `
            Pero esos cambios sucedieron MUY MUY lentamente—
            a través de cientos de miles de años. Los seres
            vivos de la Tierra tuvieron tiempo para adaptarse a los 
            cambios del clima. Pero quemar combustibles fósiles ha 
            vertido enormes cantidades de CO2 al aire en sólo unos 
            cuantos CIENTOS de años.`,

      `Esto es MUY MUY MUY MUY rápido.
            ¿Cuántos seres vivos
            se podrán adaptar
            a cambios tan rápidos?
            ¿Cómo cambiará la manera en 
            que viven ustedes los humanos?
            `,
    ],
    17: [
      `Billones de toneladas de combustibles fósiles—mi energía solar—
            aún existen encerradas profundamente dentro de los cofres de la Tierra.`,

      `Si los quemas, la capa de CO2 de 
            la Tierra se hará más y más espesa.`,

      `Tu Tierra se calentará tanto que cambiará
            en maneras que nadie puede predecir con seguridad.
            `,
      `Pero cambiará.`,
    ],
    18: [
      `¿Continuarán ustedes los humanos quemando
            más y más combustibles fósiles cada año
            y arriesgarán los cambios que esto traerá?`,

      `¿O trabajarán juntos para usar 
            mi antigua luz solar más lentamente,
            encontrar otras fuentes de energía, e inventar maneras
            de disminuir la capa de CO2?`,

      `La decisión es tuya.
            `,
    ],
  },

  riversOfSunlight: {
    1: [
      `RÍOS DE LUZ`,

      `CÓMO EL SOL MUEVE AL AGUA ALREDEDOR DE LA TIERRA`,

      `por Molly Bang
            y Penny Chisholm
            `,
    ],
    2: [
      `Yo soy tu Sol.
            Mi energía calienta tus días.
            Yo ilumino tu planeta Tierra.`,

      `Pero de todos mis planetas,
            sólo uno está lleno de VIDA:
            la Tierra. ¿Por qué?
            Porque está cubierta de agua --H2O—
            siempre moviéndose, siempre cambiando, de líquido
            a sólido a vapor y de nuevo a líquido.`,

      `Juntos, el agua y yo
            damos VIDA a tu planeta azul,
            y a TI.
            `,
    ],
    3: [
      `
            Casi toda el agua de la Tierra
            Está en tus mares salados.`,

      `A ti,
            los océanos te parecen muy profundos.
            Pero realmente son sólo
            una capa muy, muy delgada cubriendo
            la mayor parte de tu planeta.`,

      `¡Mira! Si TODA el agua de la Tierra fuera acumulada 
            en una esfera, la esfera sería de ESTE tamaño ->
            comparada con toda la Tierra.
                      Una esfera de sólo el agua dulce
                      sería tan sólo de ESTE tamaño, ->
                      y la mayor parte de esta está encerrada 
                      como hielo o agua subterránea.`,

      `¿Qué queda?
            
                                          Sólo ESTA
                                          diminuta cantidad
                                          de agua dulce.`,

      `Y sin embargo esta diminuta 
            cantidad es suficiente para mantener
            viva a TODA la vida de la tierra. ¿Cómo?`,

      `¡Porque el agua se mueve—
                                circula!
            
                                          Y entonces es utilizada una
                                          y otra, y otra, y otra vez.
            
            `,
    ],
    4: [
      `
            Bebe un vaso de agua. Siente como fluye por tu cuerpo.
            La mayoría de tu cuerpo está hecho de agua.
            El agua transporta alimento y oxígeno a cada célula
            y ayuda a mantener tu temperatura perfecta.`,

      `El agua que bebes se queda dentro de ti por unos días
            y luego continúa su camino, eliminando tus desechos.
            Así como el agua fluye y circula dentro de ti,
            fluye y circula por la Tierra—
            manteniendo viva a TODA la vida.`,

      `¿De dónde vino tu agua?
            
                      ¿A dónde va?
            
                                ¿Qué la mantiene en movimiento?
            `,
    ],
    5: [
      `
            ¡Lo hago yo! Tu sol.`,

      `Levanto agua de los mares salados
            al calentar las aguas superficiales del océano.
            Mira como mi calor hace que las moléculas de H2O
            se sacudan, hasta que explotan en el aire
            dejando atrás su sal.`,

      `¡Eso es EVAPORACIÓN!
            
            El agua líquida se convierte en un gas: vapor de agua.`,

      `Las moléculas de
            vapor de agua dulce y pura 
            FLOTAN Y SUBEN…SUBEN…
            `,
    ],
    6: [
      `
            … Y SE EXTIENDEN.`,

      `Y se unen a una capa de vapor de agua que
            envuelve a toda la Tierra.
            Esta capa captura algo de mi energía luminosa
            y ayuda a mantener la temperatura perfecta 
            para que haya VIDA en la Tierra.`,

      `Algo del vapor de agua sube aún más,
            hacia capas más frescas de la atmósfera. Cuando una molécula
            de vapor captura a una mota de polvo, de pronto
            se unen millones más, para formar una sola gota.`,

      `El vapor de agua se vuelve líquido de nuevo.
            
                      Las gotas se juntan en nubes.
            
                      Se vuelven más grandes, más pesadas,
            
                      hasta que se derraman del cielo
            
                      como lluvia o nieve,
            
                      y caen de nuevo al mar.`,

      `Pero algo del vapor de agua sobre el mar…
            `,
    ],
    7: [
      `
            …se une a un río de vapor de agua que vuela por los cielos.`,

      `Mis vientos empujan a ese río
            por los cielos hacia la tierra.
            Ahora cae lluvia y nieve ahí.`,

      `La nieve se acumula en las cimas de las montañas
            cada invierno. En el calor
            de la primavera, se derrite y fluye
            junto con la lluvia hacia arroyos,
            ríos, y lagos.`,

      `¿Ves cómo algo del agua se filtra
            profundamente en la arena y grava?
            Estas detienen el agua como una esponja gigante sobre un piso de roca sólida. Estas esponjas empapadas subterráneas son
            ACUÍFEROS. `,

      `Los acuíferos son depósitos de agua dulce,
            que guardan agua profunda y quieta
            por miles de años.
            `,
    ],
    8: [
      `
            Por encima de ellos,
            mantengo el agua en movimiento.`,

      `Brillo mi luz sobre lagos, ríos
            y tierra empapada.
            
            De nuevo, el agua se evapora
            en el aire.`,

      `Brillo mi luz
            sobre árboles y plantas.
            
            Estos jalan agua de la tierra y usan
            mi luz para la fotosíntesis—creando
            más plantas, que alimentan a todos los seres vivos de la Tierra.
            
                      Al realizar la fotosíntesis, las plantas
                      bombean vapor de agua al aire.`,

      `Y éste sube para unirse al gran río de vapor en el cielo.
            `,
    ],
    9: [
      `
            Mis vientos empujan al río volador, para que la lluvia
            y la nieve caigan en las montañas, praderas, bosques,
            y desiertos, nutriendo a sus plantas.`,

      `Y así el agua circula
            y circula, una y otra
            y otra vez.`,

      `¿Qué pasaría
            si yo NO moviera el agua?`,

      `No habría lluvia, ni ríos…
            ni VIDA en tu planeta azul
            si yo no moviera el agua.`,

      `¡Y yo muevo MUCHA agua!
            `,
    ],
    10: [
      `
            Cada año evaporo CIEN cuatrillones
            de galones de agua dulce de los mares.
            Cada año mis vientos soplan una 
            décima parte de esa agua dulce—
            DIEZ cuatrillones de galones—
            hacia la tierra. `,

      `El resto cae
            de nuevo al mar.
            
                      ¿PERO—
                      si yo sigo moviendo agua dulce de los mares a la tierra,
                      por qué los mares no se vuelven cada vez más salados?
                                ¿Y por qué no se secan eventualmente?`,

      `Porque cada año los ríos del mundo 
                                       regresan DIEZ cuatrillones de galones de agua dulce
                                          a los mares, reemplazando lo que se perdió.`,

      `Yo mantengo el agua en movimiento,                                  
                                                    circulando del mar al aire, a la tierra, 
                                                    y de nuevo al mar.
                                                    Yo mantengo el equilibrio del ciclo.`,

      `Y también circulo agua DENTRO de los mares.
            `,
    ],
    11: [
      `
            Sí, yo muevo un río gigante
            DENTRO de los mares.
            
            Así como el agua circula en TI, para
            alimentarte, sacar tus desechos, y
            regular tu temperatura, el
            río oceánico hace lo mismo 
            por los mares.`,

      `¿Cómo?
            
            Mi luz calienta el ecuador de tu Tierra
            continuamente todo el año, para
            que el agua de la superficie de ahí se mantenga muy tibia.`,

      `Mis vientos ayudan a mover una amplia corriente de esa
            agua tibia hacia el oeste, hasta que…`,

      `La corriente rebota contra la tierra—¡las Américas! —
            y se riza de nuevo en remolinos
            `,
    ],
    12: [
      `
            ¿Ves cómo la corriente tibia
            surge hacia el norte
            y luego curvea hacia Europa?
            
            Esta es la Corriente del Golfo—parte
            del enorme río oceánico.`,

      `Al fluir la Corriente del Golfo,
            el calor sube de sus aguas,
            calentando el aire de arriba.`,

      `Mis vientos soplan
            ese aire tibio 
            sobre la tierra, en donde
            calienta a la tierra misma.
            
            Si la Corriente del Golfo no fluyera,
            los inviernos en Europa
            serían MUCHO más fríos!`,

      `Al ir soltando su calor, el agua
            de la Corriente del Golfo se enfría. En el extremo norte,
            parte de ella se congela y se convierte en HIELO sólido,
            empujando su sal hacia afuera y hacia el mar.
            `,
    ],
    13: [
      `
            Más ligero que el agua, el hielo flota.
            ¿Ves cómo se suspende en el mar frío y super salado?
            
            El agua salada es más pesada que el agua dulce.
            El agua fría es más pesada que el agua tibia.
            
            El agua fría contiene más oxígeno
            que el agua tibia.`,

      `Por lo tanto, las aguas árticas
            frías, saladas, pesadas y ricas en oxígeno
            se sumergen y se convierten en una
            colosal cascada dentro del mar.`,

      `Esta se desploma a DOS MILLAS 
            de profundidad—impulsando 
            al gran río a lo largo
            del suelo marino.
            
            Esta gran arteria 
            de agua es la gran 
            Cinta Transportadora Oceánica.
            `,
    ],
    14: [
      `
            La Cinta Transportadora Oceánica serpentea
            a través del profundo y oscuro
            océano, transportando oxígeno
            a las criaturas de las profundidades y
            recolectando nutrientes que
            bajan de la superficie.`,

      `Cerca de Antártica la corriente
            se divide en dos. Eventualmente ambas
            corrientes suben hacia el agua
            soleada de la superficie, trayendo los
            nutrientes al fitoplancton
            que alimenta a toda la vida marina.`,

      `Mi corazón calienta las
            corrientes. La lluvia que cae
            diluye sus aguas saladas.`,

      `Girando, fluyendo hacia el oeste, las corrientes
            se unen y se mezclan al fin con la Corriente del Golfo
            para comenzar su ciclo de nuevo.
            
            Impulsada por cambios
            de sal y de temperatura—
            impulsada por MI, tu sol—
            la Gran Cinta Transportadora
            mantiene vivos a los océanos
            y regula la temperatura de la Tierra.
            `,
    ],
    15: [
      `
            Sí, mi energía solar mantiene en movimiento
            al agua por el planeta—en los mares,
            el cielo, y la tierra, trayendo vida a tu mundo.`,

      `El agua en movimiento también cambia el paisaje de la Tierra.
            Gota por gota, el agua puede consumir piedra dura.
            Durante eones, excava cañones profundos en la tierra.`,

      `A medida que fluye sobre rocas, el agua extrae minerales
            esenciales—nutrientes—transportándolos a
            todos los seres vivos, incluyéndote a TI.
                El agua se filtra en las grietas y se congela, quebrando peñascos en pedazos, llevando las piedras hacia abajo, abajo hasta las llanuras.
            Enormes glaciares—ríos de agua congelada—
            cavan profundos valles en las imponentes montañas.`,

      `¡El agua es suave y 
            maleable, pero muy
            poderosa!
            `,
    ],
    16: [
      `
            Por billones de años, yo, tu sol, he circulado agua
            por la Tierra mientras tus ancestros hacían sus hogares cerca de lagos y ríos para poder tener suficiente agua.`,

      `Construyeron grandes civilizaciones al
            inventar sistemas de agua--	`,

      `Cavando pozos y construyendo presas, canales, y 
            acueductos para controlar el flujo del agua.
                 A medida que crecía su población, el agua podía alimentar más y más 
            cosechas, y manadas más 
            grandes de animales.
            `,
    ],
    17: [
      `
            La cantidad total de agua en tu Tierra siempre será 
            la misma. Pero ahora, más de siete billones de personas 
            viven en la Tierra, vaciando desechos en los ríos, lagos, y
            costas, usando y moviendo demasiada agua.
            Algunos ríos se están secando. Algunos acuíferos están
            siendo drenados más rápido de lo que la lluvia los puede reponer.`,

      `El equilibrio del agua en el mundo está cambiando.
            
            Más y más lugares tienen escasez de agua:
            La sequía seca sus cosechas.`,

      `Más lugares tienen 
            demasiado: Inundaciones
            arrasan la tierra.
            
            A medida que tu Tierra se calienta,
            el equilibrio cambiará aún más. Los
            niveles de los mares subirán, inundando ciudades costeras.
            `,
    ],
    18: [
      `ESTA ES MI PROMESA:
        
            Yo, tu sol, haré mi parte
            para mantener el agua de la Tierra
            limpia y fluyendo.`,

      `¿Harás tú tu parte?
            ¿Encontrarás maneras de usar el agua
            con moderación y de mantenerla limpia?`,

      `RECUERDA:
            
            Tú compartes el agua de la Tierra
            con todos los seres vivos,
            y tu vida depende 
            de toda la red de la vida.
            `,
    ],
  },

  globalWarmingExpress: {
    1: [
      `El Tren del
Calentamiento
Global`,
      `Escrito por Marina Weber`,
      `Ilustrado por Joanna Whysner`,
      `Prólogo por el Senador de los Estados Unidos Tom Udall`
    ],
    2: [
      `Para nuestra maestra de tercer grado, Barbara McCarthy, quien nos inició
en este viaje.`
    ],
    3: [
      `Contenido`,
      `Prólogo`,
      `Reconocimientos`,
      `Personajes`,
      `Mapa`,
      `Introducción`,
      `The Fluff`,
      `Creamy`,
      `El Tren Mágico`,
      `Nuevo México`,
      `Incendio`,
      `El Efecto Invernadero`,
      `Flora`,
      `Edgar`,
      `El Momento Crítico`,
      `Las Arenas Petrolíferas`,
      `Lady Athabasca`,
      `La Costa del Golfo`,
      `Acorn Creek`,
      `La Ciudad de Nueva York`,
      `La Tormenta`,
      `La Casa Blanca`
    ],
    4: [
      `Prólogo`,

      `Mi padre solía decir que cada generación tiene un encuentro con la tierra. Se nos confía la tierra. Ese es nuestro legado de quienes nos preceden. Es nuestra obligación hacia los que nos siguen. Somos mayordomos de este planeta, y de todos sus hábitats y tesoros naturales.`,
        `Hace cinco años, Marina Weber me contactó. Me dijo que estaba escribiendo un libro sobre el calentamiento global, y me pidió ayuda. Marina puede haber sido muy joven, tenía solo nueve años, pero ella estaba decidida. Y cumplió con su palabra. Ella escribió su libro, y qué libro tan memorable ha resultado ser.`,
        `Marina y su talentosa amiga, Joanna Whysner, quien a proveído maravillosas ilustraciones, han creado una fábula moderna. Al hacerlo, están haciendo sonar la alarma sobre el reto muy real del cambio climático.`,
        `En su historia, dos niñas viajan a Washington D.C., en un tren mágico. Su misión: decirle al mundo que debemos cambiar. Su lección: Podemos cambiar si todos trabajamos juntos.`
    ],
    5: [
      `En cada paso de su travesía, conocen a algunos de los animales que han sido lastimados o dejado huérfanos, o ambas cosas, debido al cambio climático. Ven el daño a nuestro aire, nuestra agua, y nuestra tierra. Desde incendios forestales y la sequía en Nuevo México, hasta un huracán en Nueva York, el mensaje es claro. El planeta se está calentando. La Tierra está en peligro. Todos debemos hacer algo sobre esto.`,
        `Como explica Marina, no podemos seguir sofocando al planeta con gases de invernadero. Nuestro mundo se está sobrecalentando. Si no hacemos todos nuestra parte, “la Tierra no puede destaparse de sus cobijas”.`,
`Marina y Joanna y sus amigos animales-- incluyendo a un pingüino exiliado llamado The Fluff, una perica estudiosa llamada Inoah, un cachorro de oso negro llamado Tomás, y un canario ángel guardián llamado Croissant—siguen adelante. Su viaje a través de nuestra nación es en un tren impulsado por la esperanza. Y su súplica a todos nosotros es esta: También tenemos que continuar. Tampoco podemos darnos por vencidos.`,
  `El Tren del Calentamiento Global es una llamada de atención sobre el gran reto del cambio climático—y una que espero que todos escuchemos.`,
    ],
    6: [
      `Gracias Marina, por una extraordinaria historia de aventuras, y por recordarnos, como lo hizo mi padre en su época, que tenemos que cuidar nuestro planeta. Tenemos que protegerlo para tu generación, y para las generaciones que vienen.`,
      `--Tom Udall, Senador de los Estados Unidos para Nuevo México`
    ],
    7: [
      `Reconocimientos`,
      `Nos gustaría dar las gracias a muchas personas quienes han ayudado a hacer este libro realidad.`,
      `A nuestros padres, quienes apoyaron la idea de escribir e ilustrar un libro; a Amy Bianco, por tanta ayuda con la ciencia; a Maggie Blanchard, por el diseño; al Senador Tom Udall, por escribir el prólogo; y al congresista Ben Ray Lujan, por escucharnos y creer en nosotras.`,
      `También queremos agradecer a todos los que son parte del movimiento de Global Warming Express (El Tren del Calentamiento Global), la Mesa Directiva, La Junta de Asesores, los internos, los voluntarios, los maravillosos donadores, Dr. Leslie Lakind, el alcalde Javier Gonzales, el exalcalde David Coss, el congresista Peter Ives, y a todos los niños GWE en todos lados. Gracias por unirse a nuestra causa y hacer la diferencia.`,
`--Marina y Joanna`,
    ],
    8: [`Personajes`,
      `La autora Marina Weber nació en Seattle y ahora vive en Santa Fe, Nuevo México, en donde ella asiste a Desert Academy. Marina ha sido una activista apasionada desde que tenía seis años. Marina se representa a sí misma en la historia. Ella cree en corregir errores y en ayudar a los demás a ser escuchados, vistos, y ayudados. También es valiente y decidida cuando se trata de completar su misión. En su viaje, Marina aprende una gran lección sobre el poder limitado de los adultos y su propio poder emergente; y aprende que no todas las travesías—de hecho casi ninguna—se mueven en línea recta u obtienen el resultado esperado. Marina llega a creer en el poder de la travesía misma, y en el poder de los que la emprenden.`,
    ],
    9: [`La ilustradora Joanna Whysner también asiste a Desert Academy. Se mudó a Santa Fe de Sleepy Hollow, Nueva York, cuando tenía ocho años. Joanna ha sido una artista seria desde muy pequeña, y ha ganado muchos premios por su arte. En la historia, Joanna crea su mundo en papel, en línea, color y forma. Su sentido de travesura y de humor le ayuda a convertir cada dibujo en una crónica. Sin embargo, el sentido de diversión de Joanna es retado por las terribles, y reales, imágenes que observa en el tren. La travesía la motiva a ver más allá de la superficie de sus imágenes, y a encontrar el valor para representar lo que es alarmante tanto como lo que es agradable. Ella llega a darse cuenta de que la verdad se tiene que decir, pero que puede ser aceptada e inclusive acogida.`,
      `The Fluff es un pingüino emperador de Antártida. The Fluff es un tipo práctico y decidido, que se da cuenta que algo anda mal en su mundo y que necesita ayuda para corregirlo.`,
      `Croissant es un canario que vuela para el Tren Panadero. El mantiene informados a los padres de las niñas sobre su paradero con notas amarillas. Lo`,
    ],
    10 : [`podrás ver en ilustraciones a lo largo del libro.`,
      `Creamy es una foca arpa nacida en Groenlandia y criada en el Zoológico de San Diego. Ella tiene una mentalidad positiva y es compasiva hacia los demás, pero es desafiada por todos los problemas con los que se encuentra en esta travesía.`,
      `Inoah es una perica del Amazonas que es mascota de Joanna. Gracias a Inoah, todos los animales y las niñas aprenden lo que necesiten saber sobre las causas y efectos del calentamiento global.`,
    ],
    11: [
      `Tomás Ascensión Leyba Gonzales es un oso negro cuya familia ha vivido en las mismas montañas de Nuevo México durante generaciones. Él y su amiga, Sally, una Salamandra de Las Montañas Jemez, son rescatados por las niñas y traídos a bordo del tren.`,
      `Flora es una osa polar del oeste de la Bahía Hudson quien se dirige por tierra al Parque Nacional Glacier. Flora es una osita fuerte, pero ella aprende que para poder salir adelante, necesita ser flexible y optimista.`,
    ],
    12: [
      `Edgar es una cabra montés que vive en el Parque Nacional Glacier. La pérdida de los glaciales y de su prado alpino lo han dejado sin ningún lugar a donde ir, así que decide unirse a la travesía.`,
      `Lauren es una caribú del bosque boreal que vive en Alberta, Canadá. Ella está desesperada por escapar del paisaje lunar en el cual se ha convertido su hogar con la extracción de arenas petrolíferas que está sucediendo, y encontrar un lugar seguro para vivir.`,
      `Lady Athabasca es una grulla blanca que pasa los veranos en sus ancestrales criaderos en el Parque Nacional Wood Buffalo. Amablemente ofrece acompañar a las niñas y a sus amigos a la Costa del Golfo de Texas para aprender sobre el derrame petrolero de Deepwater Horizon.`
    ],
    13: [
      `En el golfo conocen a Zolo, un patito joyuyo muy platicador que perdió a su familia durante el derrame petrolero de Deepwater Horizon.`,
`Bobbie Sue Sunfish es un pez luna verde de Acorn Fork Creek en Kentucky. A Bobbi Sue no le importa para nada el calentamiento global, pero cuando se da cuenta que los esfuerzos para evitarlo también limpiarían el agua, decide subir a bordo.`,
`Zingo es una rata café que vive en las alcantarillas de la ciudad de Nueva York. Él es un viejo hippie en peligro de volverse completamente indiferente hasta que conoce a Marina y a Joanna. Con un brillo militante en sus ojos, les enseña a las niñas sobre el poder del activismo político.`,
    ],
    14: [
      ``
    ],
    15: [
      `Introducción`,
      `Hola, mi nombre es Marina, y estoy aquí para hablarles sobre el calentamiento global. Estoy en secundaria en Desert Academy en Santa Fe, Nuevo México. He estado interesada en el calentamiento global desde tercero de primaria, cuando aprendí que el calentamiento global está arruinando los hábitats de los animales de la selva tropical. El calentamiento global es muy importante para mí, porque quiero que mis hijos, nietos, y bisnietos tengan vidas felices sin tenerse que preocupar por el medio ambiente.`,
        `Nuestra Tierra se está calentando principalmente debido a los gases que bombeamos a la atmósfera cuando quemamos combustibles fósiles para conducir nuestros autos, calentar nuestras casas, usar nuestros electrodomésticos, y fabricar cosas. Necesitamos`,
    ],
    16: [
      `pensar sobre lo que le estamos haciendo a la Tierra porque está cambiando rápido! Ahora tenemos tiempo limitado para disminuir la velocidad del calentamiento global. Continúa leyendo y verás lo que quiero decir.`,
`Le escribía al presidente Obama sobre el cambio climático, y siempre me contestaba. Al menos, creí que me contestaba, hasta que un día me di cuenta de que todas las respuestas que había recibido de él eran básicamente iguales.`,



`Esto es lo que decía una de ellas:`
    ],
    17: [
      `LA CASA BLANCA`,
      `WASHINGTON`,
      `8 de Abril, 2010`,
      `Querida Estudiante:`,
`Gracias por tu amable nota. Tus palabras consideradas se unen a un coro de millones de americanos quienes están ansiosos de dirigir a nuestra nación hacia un mejor mañana.`,
  `Cada día, soy inspirado por los mensajes alentadores de esperanza y determinación que he recibido de estudiantes de todo el país. América necesita jóvenes como tú que están estudiando duro en la escuela, sirviendo a su comunidad, y soñando grandes sueños. Nuestro país confronta grandes retos, pero los superaremos si trabajamos juntos.`,
  `El futuro de América será determinado por nuestra voluntad de apoyarnos unos a otros y avanzar como un pueblo y una nación. Con tu ayuda, construiremos sobre lo que ya hemos logrado y pondremos una nueva base para progreso real y duradero.`,
  `Sinceramente,`,
  `(Barack Obama signature)`,
    ],
    18: [
      `El año pasado aprendí que esto es lo que llaman una carta modelo. Probablemente un compañero de trabajo del presidente leyó mis cartas y me contestó. A pesar de que yo escribía mis cartas al presidente a mano, obviamente él no las leía. ¡Así que decidí que escribiría un libro sobre el calentamiento global y se lo traería al presidente!`,

  `Esta es mi buena amiga Joanna. Ella es una increíble artista, así que le pregunte, “Joanna, me preguntaba si - y puedes decir que no- ¿harías algunos dibujos para ilustrar mi libro?`,
    ],
    19: [
      	`“Necesito mostrar cómo los hábitats de los animales están siendo destruidos, para que los adultos puedan entender que tenemos que hacer algo sobre el calentamiento global. El Dr. James Hansen, un famoso científico del clima, me dijo que los animales están trabajando duro para adaptarse al cambio climático, pero creo que necesitan nuestra ayuda. ¿Me ayudas?”`,

	`A Joanna le encantó la idea del libro, y dijo, “¡Llamémoslo El Tren del Calentamiento Global e invitemos a otras personas a subir a bordo!”`,

	`Así que ahora les voy a contar sobre El Tren del Calentamiento Global y nuestro viaje a ver al presidente en Washington D.C.`,

  `La historia comienza en la Antártida…`,
    ],
    20: [''],
    21: [
      `The Fluff`,

`Una tarde tibia y soleada de primavera, en el cementerio de pingüinos en la costa de Queen Maud Land, Antártida, un pequeño pingüino emperador llamado The Fluff lloraba por su madre. Ella había muerto tras haberse tragado un pedazo de plástico que flotaba en el océano.`,



`Después del funeral, los miembros de su colonia le ofrecieron el pésame y se retiraron, dejándolo solo, sentado en una roca y mirando hacia el mar. El recordaba haberse sentado en esta misma roca cuando era mucho más pequeño, un día frio y soleado de primavera cuando habían enterrado a su abuelo. Ahora la roca se encontraba bajo el agua, y el sol se sentía caliente en su espalda.`,
    ],
    22: [
      	`“¿Por qué está el agua tan alta y el sol tan caliente?”, se preguntaba.`,

  `Se quitó su gorro y se rascó la cabeza con su aleta.`,

	`“Si esto continúa,” pensó, “pronto no quedará cementerio.”`,



	`The Fluff era muy inteligente y siempre había sido de gran ayuda a su colonia. Cuando otro pingüino tenía un problema, The Fluff siempre tenía una solución, pero él no podía entender que le estaba sucediendo a su tierra. Ahora, por primera vez en su vida, se sentía un poco temeroso.`,
],
    23: [
      `“¡A pesar de que odio tenerme que ir,” pensó, “por el bien de la colonia, tengo que encontrar la respuesta a esto!”`,

	`Su padre había sido capitán marino pingüino quien había naufragado en alta mar cuando The Fluff era muy pequeño. Todo lo que The Fluff tenía para recordarlo era su pequeño bote salvavidas. The Fluff miro hacia el mar, sintiéndose solo en el mundo. “Necesito encontrar a mi amiga Creamy.” pensó, “¿Pero, cómo puedo llegar a ella?`,
    ],
    24: [
      `¡Zas! Se le prendió un foco en la cabeza. “¡El bote salvavidas anaranjado de mi papá!” pensó. “¡Puedo usar eso!”`,

`The Fluff se empujó al mar Weddell cuando el sol se ponía.`,

`El remaba todo el día y flotaba en la corriente de noche, soñando sobre su encuentro con Creamy. Al despertar una mañana, vio tierra. Después él se enteraría de que estaba en el Golfo de California.`,
    ],
    25: [],
    26: [
      `Entonces, The Fluff, quien había vivido toda su vida en agua fría y hielo, de pronto sintió una cálida brisa del sur y olió el delicioso aroma de camarón. Al acercarse a la costa, él sabía que estaba muy lejos de casa, pero mucho más cerca de su querida Creamy. Hambriento, preocupado, y de pronto sintiéndose muy acalorado, The Fluff amarró su bote y fue en busca de aire acondicionado y una ducha fría.`,

        `Acostado en su cama de hotel esa noche, se preguntó cómo encontraría a su amiga. Hasta donde él sabía, ella aún estaba en el zoológico de San Diego.`,
    ],
    27: [
      `The Fluff cayó en un profundo sueño, lleno de molestos sueños. Imágenes de su madre y de su padre iban y venían mientras que él daba vueltas en la cama. En todas las fotos de su hogar, el océano subía y subía. A medianoche, The Fluff despertó sobresaltado. Se sentó y se dio cuenta de que necesitaba más que a su vieja amiga. Necesitaba ayuda de muchos otros para él y para su mundo.`,

        `El necesitaba ayuda de aquellos en quien jamás había confiado, o siquiera conocido antes.`,
    ],
    28: [
      `Creamy`,

      `La siguiente mañana Creamy despertó en su cueva de plástico con el sonido de golpes y estruendos. Había surgido un alboroto justo afuera de su recinto. Los empleados del zoológico corrían de un lado para otro, gritando sobre un pingüino que parecía se había escapado.`
    ],
    29: [

      `Creamy escuchaba a medida que el alboroto se acercaba. Un joven pingüino casi del mismo tamaño de Creamy se aproximaba hacia el recinto de focas en donde vivía Creamy. Mientras el abría la puerta con su pico y entraba apresurado, se acercó a Creamy y preguntó, “¿En dónde me puedo esconder?” Ella se apresuró con el nuevo pingüino hacia unas rocas artificiales cercanas. Ella le dijo, “Soy Creamy”.`,

`The Fluff se le quedó viendo azorado. “¡Por fin te encontré!” le dijo. “¿Te acuerdas de mí? Te visité en el zoológico cuando tenía seis años mientras viajaba con mi padre, el capitán marino. Te dije que algún día volvería para liberarte.”`,
    ],
    30: [
      `“¡Te recuerdo!” exclamó muy fuerte Creamy. “¡Tenías plumas esponjosas por todos lados!”`,

`“Sí, por eso me llamó mi padre The Fluff.” Luego dijo, “¿Me puedes ayudar? Necesito ayuda. Mi tierra necesita ayuda. ¡Tú necesitas ayuda!”`,

`Creamy era una foca arpa. Como todas las focas arpa, Creamy había sido dejada en el hielo al nacer en el este de Groenlandia cuando tenía solo doce días de nacida. Aun no estaba lista para nadar cuando, debido al calentamiento global, el hielo en el que se encontraba se derritió demasiado temprano. Ella se hubiera ahogado de no ser por dos amables biólogos de vida silvestre que la encontraron y rescataron. La mandaron al zoológico de San Diego, California, y de ahí en adelante jamás volvería a ver a sus padres.`,
    ],
    31: [
      `Desde entonces, Creamy se había estado preguntando qué le estaba sucediendo al planeta. Ella siempre había sido muy amable, y siempre trataba de ayudar a quienes lo necesitaban. A Creamy se le ocurrió la idea de preguntarles a los otros animales del zoológico si sabían algo sobre lo que le estaba pasando al planeta. De esta manera, aprendió mucho sobre el medio ambiente.`,

        `Ahora The Fluff la había encontrado, y tenían mucho de qué hablar. Platicaron hasta muy noche. Se dieron cuenta de que ambos ahora se encontraban solos. Se necesitaban. Y necesitaban encontrar una manera de ayudar al mundo a no cambiar tan rápidamente.`,

        `Decidieron que necesitaban algún tipo de transporte humano para salir del zoológico.`,

	`“He escuchado que hay un viejo tren del zoológico que no se ha usado en más de treinta años, pero tal vez funcione,” dijo Creamy. “Siempre se nos dijo que tenía algo especial, pero nadie recuerda qué es.”`,
    ],
    32: [
      `“Genial,” dijo The Fluff. “¡Vamos!”`
    ],
    33: [
      `El Tren Mágico`,

      `Esa noche era el solsticio de verano, el día más largo del año. Al caer la noche y cuando todos los animales del zoológico se fueron callando, los dos amigos salieron a escondidas del recinto de las focas. Al acercarse al cobertizo en donde el tren abandonado había estado sin usarse por tantos años, escucharon ruidos extraños, como metal rechinando. Creamy miró a The Fluff, sus ojos brillando con emoción.`,

	`“Algo maravilloso va a pasar,” ella susurró. “¡Lo siento!”`,

	`Asomándose por las ventanas sucias del cobertizo, ellos vieron al tren sacudirse y temblar. Vieron décadas de polvo y óxido caer de su cuerpo hasta que la vieja máquina de vapor parecía brillar. Entonces el cobertizo mismo comenzó a sacudirse y temblar. ¡The Fluff y Creamy también temblaban y se sacudían al mirar al tren crecer al doble ante sus ojos! Hermosas burbujas de colores y mariposas aleteando llenaban el cobertizo, y con un crash! Las puertas grandes se abrieron repentinamente y el tren se movió en la noche bajo la luz de la luna, deteniéndose enfrente de`,
],
    34: [
      `los dos amigos.`,

        `La puerta del primer vagón se abrió, y antes de que el supiera lo que estaba pasando, The Fluff sintió a Creamy empujarlo y subirlo al tren. Creamy iba detrás de él, aplaudiendo sus aletas.`,

	`“¡Aquí vamos!” ella reía.`,

  `Con sus narices pegadas en la gran ventana, veían como el tren avanzaba bajo la luz de la luna pasando las jaulas de los animales, por la ciudad durmiente, y hacia el océano. Justo cuando pensaban que iban a entrar al mar, el tren giró bruscamente hacia la derecha y se dirigió hacia el norte por la costa.`,
],
    35: [
      	`“¡Wow!” The Fluff se dijo a sí mismo. “Me pregunto a donde vamos.”`,

	`Exhaustos de tanta emoción, ambos se echaron en los cómodos asientos y miraron por la ventana a los paisajes que iban pasando.`,

  `Después de rato, a The Fluff se le ocurrió algo. “¿Que combustible usa este tren? preguntó. “No veo nada de humo.”`,

`“¡Mira!” contestó Creamy, apuntando por la ventana.`,

  `Burbujas y mariposas habían llenado el aire alrededor del tren. La imagen de las hermosas burbujas y mariposas en la brillante luz de la luna los hizo a ambos sentir muy felices y con esperanza.  Y al sentirse así, parecía que el tren viajaba a una velocidad más alta.`,

	`“¿Por qué aceleramos?” preguntó The Fluff. Entonces tuvo una idea inspirada. “¡Oh, espera un momento! ¡Tal vez cuando tenemos pensamientos felices y positivos, el tren se acelera!”`,
    ],
    36: [
      	`“Entonces, si estamos tristes o negativos... ¿el tren irá más despacio?” se preguntó Creamy.`,

	`“Intentémoslo,” dijo The Fluff. “Piensa en algo muy triste. Piensa en—“`,

`“—nuestros padres,” dijo Creamy.`,

  `Se miraron con lágrimas en los ojos. Entonces otra sacudida los hizo mirar por la ventana de nuevo. El tren iba muy despacio. Se miraron el uno al otro, sus ojos grandes al comprender.`,

	`“Yo creo,” murmuró Creamy, “que es mejor que pensemos positivamente.”`,
    ],
    37: [
      	`“Creo que tienes razón Creamy,” dijo The Fluff.`,

	`“¡Podemos hacerlo!” él gritó.`,

	`“¡Sí, sí podemos!” gritó Creamy.`,

  `Entonces ambos exclamaron, “¡Vamos, hermoso tren, hagámoslo!”`,

	`Y una vez más, el tren estaba rodeado de millones de burbujas y mariposas. Avanzó adelante en la noche, y casi parecía volar!`,
    ],
    38: [
      `Nuevo México`,
      `La siguiente mañana, Creamy amaneció justo a tiempo para ver un letrero que decía, “Bienvenido a Nuevo México.”`,
      `“¿Me pregunto por qué el tren nos trajo aquí?” dijo Creamy. “Tendremos que esperar para saberlo,” contestó The Fluff.`,
      `Ya pasaba de la medianoche cuando llegaron a una vieja reja de madera en un muro de adobe.`,
      `“No nos bajemos todavía,” dijo The Fluff. “Presiento que ellos vendrán a nosotros, quienquiera que sean.”`,
    ],
    39: [
      `,entro de la casa, Marina despertó a su amiga Joanna. “Creo que hay algo afuera,” susurró.`, `“Aaaaaa … léjame en paz” bostezó Joanna.`,
      `“¡Joanna!” Marina la tumbó de la cama.`,
      `“¡Okey, okey!” dijo Joanna al pararse. “¿Despierto a mis padres?”`,
      `“Pues…,” dijo Marina, mirando por la ventana. “No creo que sea necesario, pero creo que será mejor vestirnos.” puso su dedo en sus labios.`,
      `“¡Squak!”`,
      `“Oh no,” dijo Joanna. “Despertamos a Inoah. Ella nunca se queda callada.”`,
      `“Tal vez debamos traerla,” sugirió Marina.`,
      `Joanna retiró silenciosamente la manta que cubría la jaula de la perica.`,
      `“¡No irse sin mí! ¡No irse sin mí!” gritaba la perica.`,
      `“Shhhh!” dijo Joanna al abrir la puerta de la jaula de Inoah. La perica caminó cuidadosamente por su brazo hasta sentarse en su hombro.`,
      `Las niñas abrieron la puerta de enfrente silenciosamente, solo para encontrar a un pingüino parado al lado de un tren que brillaba en la noche.`,
      `“¿Quién eres?” el pingüino y las niñas preguntaron al mismo tiempo. Pero antes de que alguno pudiera contestar, el tren comenzó a moverse.`,
    ],
    40: [`“¡Vengan!” gritó The Fluff al brincar dentro de la puerta abierta. “¡Las necesitamos! ¡El tren las encontró porque pueden ayudar!”`,
      `“¿Qué?” gritó Joanna.`,
      `El tren se iba. “¡Corre!” gritó Marina. “¡Vamos!”`,
      `Pero antes de que se dieran cuenta, estaban siendo jaladas a bordo. “¡Estoy siendo jalada por…aletas!” dijo Joanna. Y de pronto estaban dentro del tren en marcha.`,
      `Creamy y The Fluff les contaron a las niñas como habían escapado del zoológico porque querían ayudar a otros animales, pero que no sabían hacia donde se dirigía el tren.`,
    ],
    41: [`“¡Hacia el Este! ¡Hacia el Este!” interrumpió Inoah.`,
      `“Esperen un momento… ¡Tal vez estaban destinados a recogernos!” exclamó Marina. “Joanna y yo queremos conocer al presidente de los Estados Unidos para decirle que el calentamiento global está perjudicando a los animales, y que se tiene que resolver inmediatamente.”`,
      `“Que hace el presidente?” preguntó The Fluff.`,
      `“El controla a los Estados Unidos,” contestó Marina.`,
      `“Bueno, entonces vayamos juntos,” dijo Creamy. “¡Nosotros también queremos hacer un cambio!”`,
    ],
    42: [`Incendio`,
      `Dentro del tren, hilos de humo flotaban en el aire.`,
      `“¿Qué es ese olor?” preguntó The Fluff.`,
      `“Oh,” dijo Marina, “es humo de un incendio forestal. Siempre hemos tenido incendios en el verano, pero en años recientes, han habido más. Joanna, huele como si tu papa estuviera cocinando el desayuno!”`,
      `Joanna sonrió. “Es porque el calentamiento global está causando terribles sequías en esta área,” dijo, seria de nuevo. “Nuevo México ha estado en sequía durante años.”`,
      `El tren traqueteo hacia dentro del Bosque Nacional Santa Fe.`,
      `“¡Oh cielos!” dijo Creamy. “¿Esto es lo que es un incendio?”`,
      `Afuera de la ventana, el sol de la mañana había desaparecido, y el cielo era gris. Surgían llamas arriba de ellos, rozando la montaña cubierta de árboles. Las niñas y sus nuevos amigos miraban con horror.`,
      `“Creo,” dijo The Fluff en voz baja, “que como el tren es mágico, no se nos puede lastimar. ¡Al menos eso espero!”`,
    ],
    43: [

    ],
    44: [`En eso, vieron a un cachorro de oso negro acurrucado bajo un árbol. La corona del árbol se estaba quemando.`,
      `El tren se detuvo tan repentinamente que una puerta se abrió de pronto. El grupo corrió a recoger al cachorrito, quien parecía estar durmiendo.`,
      `“Carguémoslo, metámoslo al tren, y vámonos de aquí,” dijo The Fluff.`,
      `Las dos niñas cargaron cuidadosamente al osito. Apenas podían ver al tren a pesar de que se encontraba a solo unos pies de distancia. Creamy no podía dejar de toser. En cuanto se treparon al tren, este salió disparado. Las puertas se cerraron mientras que entraba humo a chorros al vagón, junto con algunas de las burbujas del tren.`,
      `Cuando Joanna acomodaba cuidadosamente al osito en un asiento, observó algo en sus patas.`,
      `“Está agarrando algo,” dijo.`,
      `“¡Pero sus patas—están quemadas!” exclamó Marina.`,
    ],
    45: [`Las niñas se miraron angustiadas. En silencio, The Fluff apuntó a las burbujas. Estaban flotando hacia el oso dormido—y cayendo en sus patas con un destello.`,
      `“Es increíble,” dijo Marina. “¡Sus patas están sanando!”`,
      `El tren ya se encontraba lejos del incendio forestal cuando el oso despertó.`,
      `“¿Quiénes son?” dijo. “¿Y qué estoy haciendo aquí?”`,
      `“Tu estabas…Nosotros somos...,” comenzó Creamy, pero se detuvo cuando una pequeña salamandra brincó al suelo. Era tan pequeña que nadie la había notado en la pata lastimada del oso.`,
      `“Esta es Sally. Ella es una Salamandra de las Montañas de Jemez,” dijo el cachorro de oso. “Y mi nombre” agregó con orgullo, “es Tomás Ascensión Leyba Gonzales—pero me pueden llamar simplemente Tomás.”`,
    ],
    46: [
      `“¡Yo soy especial!” chilló la pequeña salamandra mientras que The Fluff la recogía torpemente. “¡Yo estoy en peligro de ex-tin-ción!”`,
      `“Sí, mijita, eres especial,” dijo Tomás cariñosamente a la salamandra.`,
      `“Mijita,” graznó Inoah. “Traducción: ¡dulce niña!”`,
      `Tomás sonrió y explicó que él había perdido a sus padres en un gran incendio el verano anterior. La misma área se había quemado varios años antes, y los árboles no habían tenido tiempo para recuperarse.`,
      `“Ahora los árboles probablemente nunca volverán a crecer,” dijo Tomás tristemente. “Sally y yo vamos a tener que encontrar otro lugar en donde vivir.”`,
      `“¡Oh, que terrible!” exclamó Creamy.`,
      `“¿Por qué no vienen con nosotros?,” dijo Marina. “Vamos a Washington D.C., a decirle al presidente que necesita hacer algo sobre el calentamiento global. Al menos creo que ahí es a donde nos dirigimos. ¡Este tren parece tener sus propias ideas!”`,
      `“¿Un presidente?” preguntó Tomás. “¿Qué es eso? Y, este, mientras me explicas, ¿me pueden encontrar algo de comida? ¡Muero de hambre!”`,
    ],
    47: [`El Efecto Invernadero`,
      `Mientras comían, Creamy le pidió a Marina que explicara esta cosa llamada calentamiento global de la cual tanto había escuchado.`,
      `“El clima de la Tierra ha cambiado en los últimos veinte años más o menos,” dijo Marina.`,
      `“¿Pero por qué tan rápido?” preguntó Creamy.`,
    ],
    48: [
      `“En parte por lo que han hecho los humanos,” dijo Marina, “como hacer fábricas y carros. Durante el último siglo más o menos, los humanos han estado usando máquinas para casi todo. Han estado quemando algo llamado combustibles fósiles—principalmente carbón, petróleo, y gas natural.”`,
      `“¿Quemando? ¿A propósito?” preguntó Creamy.`,
      `“Sí,” dijo Joanna. “Quemamos combustibles fósiles para generar electricidad para fábricas, y para calentar y enfriar casas y edificios. También los usamos como combustible para tractores, camiones, trenes, aviones, y carros. Ahora, nuestro estilo de vida entero funciona con combustibles fósiles.”`,
      `“¿Es por eso que a veces se ensucian tanto el aire y el agua?” preguntó Tomas.`,
    ],
    49: [
      `“Sí,” dijo Marina, “pero eso no es todo. Este quemar--de los combustibles fósiles—está cambiando a la atmósfera entera.”`,
      `“¿Perdón?” preguntó Creamy.`,
      `“La atmósfera es el aire—lo que está a nuestro alrededor,” explicó Joanna. “Hace que la vida en la Tierra sea posible al retener el calor del sol. Sin ella, nuestro planeta sería una roca fría y vacía, o una ceniza quemada, como otros planetas.”`,
      `“¿Planetas?” preguntó The Fluff.`,
      `“Pues, sí, te explico más sobre eso después,” dijo Joanna.`,
      `Los animales se quedaron callados y se veían confundidos.`,
      `Inoah rompió el silencio: “Hay gases en la atmósfera—dióxido de carbono, vapor de agua, metano, óxido nitroso, y otros—`,
    ],
    50: [`que atrapan la luz del sol para que no se emita de nuevo al espacio. Esto es como la luz solar en un invernadero de vidrio que hace que las plantas estén tibias aun en invierno, por eso se le llama el efecto invernadero.”`,
      `“¿Un invernadero?” preguntó Creamy. “En dónde está?”`,
      `De pronto se escuchó un sonido como de rasgado proviniendo de la pared, y una pantalla como en las que se muestran películas se desenrolló con un snap! Comenzó a mostrarles imágenes que se movían como un video, pero se dieron cuenta que era real. La pantalla parecía estar mostrándoles mágicamente lo que sucedía afuera del tren, pero con más detalle.`,
      `“¡Wow!” dijeron Marina y Joanna al mismo tiempo.`,
      `“¡Así es como se deben ver los gases de invernadero!” dijo Marina.`,
      `“Para un químico,” agregó Joanna.`,
      `La pantalla brillaba con colores. Capas de rojo, gris, y amarillo mostaza fluían de una a otra.`,
      `“Usualmente no podemos ver el dióxido de carbono,” explicó Marina mientras apuntaba a la pantalla.`,
      `“Las plantas absorben dióxido de carbono para crecer. Así es como hacen su comida,” dijo Joanna.`,
      `“Entonces es bueno?” Creamy miraba de una niña a la otra.`,
      `“Sí, es bueno,” contestó Marina. “El problema es que hemos estado produciendo demasiado CO2.”`,
      `“CO2: significa dióxido de carbono,” interrumpió Inoah.`,
      `“Las plantas no lo pueden absorber todo,” continuo Marina. “Así que ahora, el CO2 sobrante y los otros gases de invernadero, están atorados en la atmósfera de la Tierra y están atrapando demasiado calor.”`,
      `“¡Fuchi!” dijeron Creamy y The Fluff juntos mientras miraban los gases girando en la pantalla.`,
      `“¿Cómo nos deshacemos de ellos?” preguntó Tomás.`,
      `Inoah intervino de nuevo: “Hay muchos métodos de almacenamiento`,
    ],
    51: [`de carbono—“`,
      `“En otra ocasión, Inoah,” dijo Joanna firmemente. “Solo digamos que primero que nada es mucho mejor evitar producir demasiado.”`,
      `“Mi amigo Flynn me dijo que el efecto invernadero es así,” dijo Marina. “Imaginen que están en la cama tapados con todas sus cobijas, y entonces les da demasiado calor, así que se destapan. ¿Se siente mejor, ¿verdad? Pues así es la Tierra, pero la Tierra no se puede destapar, así que solo se acalora cada vez más. ¡Eso es el calentamiento global, y no es bueno!”`,
    ],
    52: [
      `Flora`,
      `Joanna se levantó temprano la siguiente mañana. Aun en sus pijamas, con Inoah en su hombro, encontró el refrigerador y se sirvió jugo.`,
      `Luego se acomodó en una cómoda silla en el vagón de observación, para ver al sol salir por encima de unas espectaculares montañas cubiertas de nieve. Un letrero pasó volando. Decía, “Bienvenido al Parque Nacional Glacier.”`,
    ],
    53: [`Mientras que el tren se aceleraba por el paisaje nevado, Joanna vio a una gran bola de nieve comenzar a bajar rodando de un cerro, causando un desprendimiento de rocas mínimo. Ella miró mientras que la bola de nieve gigante rodaba sobre las vías y se detuvo. El tren se detuvo con un movimiento repentino, y Joanna escuchó golpes y gemidos del vagón para dormir.`,
      `Luego escucho a The Fluff quejarse: “¡Au!”`,
      `Las niñas y los animales salieron cayéndose del tren para ver a la misteriosa bola de nieve que se quitó rodando de las vías—¡Y se paró! “¡Es una pequeña osa polar! Exclamó Joanna. “¡Qué linda!”`,
      `“¿Qué es un oso polar?” preguntó The Fluff.`,
      `“Un animal muy peligroso,” contestó Creamy, mientras se escondía detrás de Marina.`,
      `“¡Hola!” dijo Marina a la nueva visitante. “¿Te puedo ayudar?”`,
      `“Pues, no estoy segura. Soy Flora. ¿Eh, puedo unirme a ustedes?” preguntó. “Ya no tengo familia.” Bajó su cabeza. “¡Y tengo mucha hambre!”`,
      `“¡Cielos!” dijo The Fluff. “¡Claro que puedes! A ninguno de nosotros nos queda familia—bueno, excepto a las humanas.”`,
      `Ahora le tocó asustarse a Flora. “¿Humanas?” exclamó. “¿Aquí?”`,
      `“Está bien,” dijo The Fluff. “Están aquí para ayudarnos.”`,
      `“¡Espera un momento!” dijo Creamy. “Yo soy una foca, y eso es un oso polar.”`,
      `“Sí,” dijo Flora. “Me criaron para comer focas, pero—“`,
      `The Fluff la interrumpio. “¡Bueno, estoy seguro de que podemos acordar algo, pero en este momento, el tren se va a ir!”`,
      `Los comenzaban a rodear burbujas y mariposas, las cuales eran la forma silenciosa del tren de echar a andar su motor de nuevo.`,
      `Una vez que estaban todos a bordo, Flora preguntó, “¿Entonces quiénes son estas humanas?”`,
    ],
    54: [`“Esas seriamos nosotras.” Marina y Joanna se acercaron de sus asientos hacia la osa polar.`,
      `“¡Oh, pequeñas humanas!” exclamó Flora. “¡Qué lindas!”`,
      `“Si, pues…yo soy Marina, y esta es Joanna.”`,
      `“De cualquier modo, tengo mucha hambre,” dijo Flora. “¿Alguien tiene algo que comer? No he comido en” -- pausó para pensar—“¡dos meses!”`,
      `“¡Guau!” dijo Tomás. “Eso es mucho tiempo.”`,
      `“Los osos polares cazan focas a través del hielo durante el invierno y la primavera,” entrometió Inoah. “Cuando el hielo se derrite, tienen que esperar en la tierra hasta que el agua se congele de nuevo y puedan volver a comer.”`,
      `Creamy tembló tan solo de pensarlo.`,
    ],
    55: [`Flora se le quedaba viendo a Inoah. “¿Qué es eso?” preguntó.`,
      `“Esta es Inoah. Ella es un perico,” dijo Joanna. “Ella sabe todo de todo, hasta de osos polares.”`,
      `“¡No me digas!” dijo Flora sarcásticamente. “Bueno, mis padres me dijeron que el hielo se ha estado derritiendo más y más temprano en años recientes, reduciendo nuestro tiempo para alimentarnos cada vez más. ¡Morimos de hambre!”`,
      `“Ven,” dijo Marina. “Te mostraremos el vagón para comer. Puedes pedir lo que quieras, y aparecerá.”`,
      `“Oh, que padre,” dijo Flora mientras se dirigía hacia la puerta.`,
      `Unos minutos después, con su boca llena de bayas, Flora murmuró, “Bo bine del boeste de la Bahia Budson.”`,
      `“¿Perdón?” dijo Sally.`,
    ],
    56: [`Flora tragó su bocado. “Yo vine del oeste de la Bahía Hudson. He estado nadando y caminando por el agua durante meses, buscando hielo porque la primavera pasada el hielo se deshizo temprano. Mis padres estaban nadando, y yo quedé atrapada sola en un pedazo de hielo de mar que se había quebrado de la capa principal. ¡Me dio tanto miedo! Mis padres se veían cada vez más pequeños mientras me alejaba mucho la corriente. Sucedió tan pronto. Estaba demasiado lejos para nadar de regreso. ¡No sabía que hacer!”`,
      `Flora explicó un poco más: “Yo vivo—bueno, vivía—en un iglú. Estaba muy bonito. Mi papá tenía un negocio local, y mi mamá administraba una escuela preescolar para cachorros de oso polar. Yo tenía muchos amigos. Pero bueno, yo creí que si tan solo podía seguir flotando, eventualmente llegaría a tierra, pero me preocupaba que se derritiera antes mi pedazo de hielo. Yo`,
    ],
    57: [`esperé durante dos puestas y dos salidas de sol, luego decidí saltar y nadar hasta encontrar tierra. Vine por un largo rio y luego a esta tierra. ¡He estado caminando y caminando por estas montañas nevadas hasta que me caí y rodé hasta llegar a ustedes!”`,
      `“Guau. ¡Qué historia!” dijo Creamy. Sus ojos estaban llenos de lágrimas. “¡Siento tanto que hayas tenido que pasar por todo eso!”`,
      `Se paró y titubeó por un momento, y luego le dio un gran abrazo a Flora.`,
    ],
    58: [
      `El tren había estado subiendo empinadamente mientras Flora hablaba. Al fin, se detuvo en un enorme y rasposo pedazo de hielo. Todo al rededor había nieve profunda y congelada. Creamy y The Fluff prácticamente volaron del tren, cayéndose uno sobre el otro en su prisa por salir.`,
      `“¡Salgamos a la nieve!” gritaron.`,
    ],
    59: [`Flora les siguió, dirigiéndose al hielo. Marina, Joanna, e Inoah siguieron, todas temblando. De pronto Flora vio algo. En una saliente rocosa arriba de sus cabezas, se encontraba un imponente y grande animal blanco con cuernos picudos, mirándolos.`,
      `“Hola. Soy Edgar.” Saltó de bajada con facilidad para llegar a ellos. “Soy una cabra montés. ¿Y ustedes son…?” los miró curioso.`,
      `Los animales y las niñas dieron un paso atrás. Rápidamente, The Fluff los presentó.`,
      `“Es bueno ver hielo de nuevo,” sonrió Flora.`,
    ],
    60: [
      `“Este hielo es nieve que se derrite y se vuelve a congelar cada año y luego es comprimida,” Edgar dijo con una voz grave y rasposa. “Todo junto baja lentamente por la montaña, con nieve nueva añadida en la superficie y agua derritiéndose por abajo. Científicos vienen aquí cada verano y lo miden porque está encogiendo.”`,
      `“Igual que los témpanos en mi bahía,” dijo Flora`,
      `“Los científicos predicen que todos los glaciales de aquí del Parque Nacional Glacier desaparecerán en los próximos diez o veinte años,” anunció Inoah.`,
      `Edgar meneó su cabeza lentamente. “Entonces se secarán los arroyos de verano,” dijo.`,
      `Lágrimas empezaron a caer de los grandes ojos negros de Creamy mientras escuchaba.`,
    ],
    61: [`La voz de Edgar era triste mientras continuaba hablando: “Los animales y las plantas de aquí están acostumbrados a vivir en ciertas partes de la montaña. Al volverse más calientes los veranos, todos nos seguimos yendo más alto a donde está más fresco. Se llama migración, pero no hay ningún otro lugar para nosotros a donde emigrar. Ya vivimos en la punta de la montaña, arriba de la línea de los árboles. Ahora los árboles están creciendo aquí arriba, así que hacen sombra que no permite que el pasto tenga la luz que necesita, y se muere. Pronto no quedará nada de comer para nosotros.”`,
      `“¿Y entonces qué vas a hacer?” preguntó Tomás.`,
      `“Podrías venir con nosotros,” dijo Marina.`,
      `“Eh…eso es muy amable de tu parte,” dijo Edgar, “pero yo he vivido aquí toda mi vida.”`,
      `“Se cómo te sientes,” dijo Tomás. “Yo también tuve que dejar mi montaña. Tenemos que adaptarnos.”`,
      `Edgar miró hacia su pradera suspirando, y hubo un silencio.`,
      `“Ahora todos estamos viajando juntos porque necesitamos ayuda,” explicó The Fluff. No podemos volver a casa hasta obtener ayuda para salvar a nuestras tierras.”`,
      `“Y a nosotros mismos,” agrego Flora.`,
      `“Entiendo lo que dices,” dijo Edgar. “Odio irme, pero…alguien tiene que saber de nuestros problemas.”`,
      `“Nosotros vamos a ver al presidente de los Estados Unidos,” dijo Marina. “¡Él nos ayudará!”`,
      `“¿Qué es un presidente?” preguntó Edgar.`,
      `Joanna sonrió. “Te lo explicaremos en el camino. ¡Vamos! Subámonos al tren. ¡Mientras más pronto nos vayamos, más pronto obtendremos ayuda!”`,
      `“¡Ayuda! ¡Ayuda! ¡Ayuda!” graznó Inoah mientras todos caminaban hacia la puerta abierta del tren.`,
      ],
    62: [],
    63: [
      `El Momento Crítico`,
      `Mientras el tren comenzaba a andar de nuevo, The Fluff se movió para pararse junto a Marina.`,
      `“¿En dónde queda exactamente Washington D.C.?” preguntó pensativamente, mientras veía el paisaje montañoso por la ventana.`,
      `“Está en la lejana costa este de este país,” le dijo Marina. “Es una gran ciudad en donde trabajan todos los adultos quienes están a cargo de administrar el país. Allí es en donde vive y trabaja el presidente.”`,
      `“Oohhh,” dijo The Fluff. “¿Siempre ha vivido ahí? ¿O emigró?”`,
    ],
    64: [`Marina rio. “¡Bueno, tal vez se pueda decir que emigró! Él fue enviado a vivir allí por la gente de los Estados Unidos. Se le llama “ser elegido”. Él fue escogido para dirigir al país, y entonces se mudó con su familia a vivir a Washington. El estará ahí por un tiempo y luego se mudará a otro lugar.”`,
      `“¿Y entonces otra persona emigrará allí y estará a cargo?” preguntó The Fluff.`,
      `“Sí,” dijo Marina. “No sabemos quién será. Y no podemos esperar. Necesitamos lograr que este presidente nos escuche ahora.”`,
      `“Siento como que el tren se dirige hacia el norte,” gritó Flora.`,
      `“Me pregunto, ¿a dónde nos lleva?” dijo Marina. “Espero que demos vuelta hacia el este pronto. ¡Se nos acaba el tiempo!”`,
      `El tren había salido de las montañas y cruzaba un llano ancho y plano. Marina vio una torre petrolera en el horizonte.`,
      `“¿Ven eso?” apuntó. “Es una máquina para sacar petróleo de la tierra.”`,
    ],
    65: [`Inoah añadió: “En los campos petroleros convencionales, el petróleo esta acumulado debajo de la tierra, y las máquinas perforan y lo bombean. El gas natural también puede ser obtenido de esta manera.”`,
      `“Los humanos ya han quemado la mayoría de los combustibles fósiles que pueden ser minados o perforados fácilmente,” agregó Marina.`,
      `Inoah agitó sus plumas y continuó en voz alta: “Ahora, las compañías de energía están buscando otras formas, más difíciles, de obtener los combustibles fósiles, como perforar en las profundidades del océano y en reservas naturales remotas.`,
      `“¿Qué son reservas?” preguntó Joanna.`,
      `“Son áreas que son conservadas, protegidas, y valoradas como un tesoro.”`,
      `“Las compañías petroleras están perforando hasta en esas áreas especiales, porque para ellas el tesoro es el petróleo,” agrego Marina.`,
      `“Como en donde vivo yo, en medio de la naturaleza ártica,” lloró Flora. “¡Hay mucha gente ahí, con grandes máquinas, cavando zanjas y construyendo oleoductos!”`,
      `“¡Por favor!” exclamó Creamy. “¡Esto es tan malo! ¿Tenemos que hablar sobre ello? El tren va cada vez más lento.”`,
      `“¡Pero necesitan saberlo!” contesto Inoah. “¡Es importante conocer los hechos!”`,
      `Todos se miraron tristemente en silencio.`,
      `“Y luego tenemos hidro-fracking por el gas natural y exprimiendo el petróleo de las arenas petrolíferas…”`,
      `“¡Okey, Inoah!” dijo Joanna. “Gracias por contarnos los hechos.”`,
      `“Con todo gusto,” contestó Inoah con orgullo.`,
      `Hubo otro gran silencio en el vagón del tren. Finalmente, The Fluff habló: “¿Marina? Dijiste que el calentamiento global está avanzando demasiado rápido, pero parece que las personas están trabajando duro para obtener más combustibles fósiles para quemar, en vez de encontrar otras formas de obtener energía. Estoy confundido.”`,
    ],
    66: [
      `“¡Si!” dijo Creamy. “Dijiste que quemar combustibles fósiles está atrapando demasiado calor en la atmosfera de la Tierra, y eso tiene que parar.”`,
      `“Es cierto,” contestó Marina. “La Tierra ya se ha calentado como 0.8 grados en el último siglo, y eso causa mucho daño.”`,
      `“No suena como mucho,” interrumpió Sally. “¿Qué 0.8 no es aún menos que 1?”`,
      `“Bueno, eso es en medida Celsius; es 1.5 grados en Fahrenheit, la unidad de temperatura a la que estamos acostumbrados,” dijo Marina.`,
      `“¿Pero 1.5—que no es menos que 2?” preguntó Sally.`,
      `“¡Sí Sally, es menos que 2, pero para la Tierra hasta un grado es mucho! Es como si la temperatura de mi cuerpo subiera dos grados…”`,
      `“¡Tu mamá te llevaría al doctor!” dijo Joanna.`,
      `“A eso se le llama fiebre,” agrego Marina, “y ahorita, la Tierra tiene fiebre. Si se sigue enfermando de esta manera, la mayoría de los animales y plantas que viven en ella morirán.”`,
      `Todos se quedaron callados. El tren se detuvo completamente.`,
      `“¡Y algunas personas aún no están de acuerdo en que toda esta actividad humana está causando este calentamiento repentino!” dijo Joanna.`,
      `“Pues, definitivamente no es por actividad animal,” chillo Sally.`,
      `“Así es,” dijo Joanna. “Y mientras discuten con las personas que quieren cambio ya, seguimos quemando combustibles fósiles.”`,
      `“Lo que los científicos entienden, “continuó Marina, “es que aun si todos acordáramos en dejar de quemar combustibles fósiles en este momento—hoy—la Tierra se seguiría calentando debido a lo que ya está en la atmósfera. Estamos poniendo al planeta en peligro simplemente al quemar los combustibles fósiles que ya tenemos, no se diga los que son difíciles de obtener. Pronto llegaremos al momento crítico, en el cual el cambio climático`,
    ],
    67: [`se acelera tanto que está fuera de control.”`,
      `“Es así,” explicó Joanna. “Imagina que la Tierra es una pelota rodando hacia la cima de una montaña. La miras y ves que solo está a la mitad del camino.”`,
      `“Si llega a la cima entonces no quedará remedio, porque caerá en bajada libre hacia el otro lado. Podemos reducir su velocidad, aunque no podemos hacer que retroceda. Pero si llegamos al momento crítico, que es la cima de la montaña, ya nunca podremos reducir su velocidad.”`,
      `“¡Eso es horrible!” dijo Creamy. “¿Cómo pueden los humanos hacernos esto a todos?”`,
      `“¿Cómo pueden hacérselo a sí mismos?” preguntó The Fluff.`,
      `“¡Escuchen todos!” dijo Marina. “Saber la verdad no quiere decir que debamos dejar que nos detenga. Todos queremos lograr un cambio. ¡Juntos, lo podemos hacer! Llegaremos al presidente. Le podremos contar todas nuestras historias y nos ayudará. ¡Lo sé!”`,
    ],
    68: [
      `El tren traqueteaba más y más rápido, echando más y más burbujas, como si la escuchara.`
    ],
    69: [`Las Arenas Petrolíferas`,
      `“Mira,” dijo Tomás. “Acabamos de pasar un letrero que dice ‘Bienvenido a Alberta, Capital Petrolera de Canadá.’”`,
      `El tren había estado andando silenciosamente dentro de un enorme bosque de pinos, pero ahora disminuía su velocidad hasta ir a paso de tortuga. La pantalla mágica se desenrollo con una vuelta. Todos se amontonaron para ver. La pantalla mostraba un video de la tierra vista desde un avión—verdes bosques que seguían por millas y millas. El video se amplió, y las niñas y los animales vieron que en las orillas de los bosques había terreno de suelo oscuro, con muchos ríos y lagos. Uno de los lagos era tan grande que parecía no terminar.`,
      `“¡El océano!” grito Creamy.`,
      `Pero pronto aparecieron las orillas del lago. Animales grandes se alejaban de él, a través de tierra oscura y rica. Tenían cuernos y parecían venados mientras se movían en fila. Uno de ellos subió su mirada al brillante cielo azul.`,
    ],
    70: [`De pronto cambió la imagen. En vez de bosques y tierra oscura, había millas de árboles muertos. En algunos lugares, habían sido retirados, y la tierra era completamente gris, del color del concreto. Nuevos “lagos” que las niñas y los animales veían, eran verde-amarillo como si estuvieran enfermos en vez de ser un hermoso azul-verde, o eran negros como el petróleo, o inclusive un extraño color anaranjado-verde. Pero el cielo se veía aún peor. Espesas plumas de humo de infinitas chimeneas llenaban el aire alrededor de millas de tubería. Entonces la pantalla se cerró de pronto, y el tren redujo su velocidad.`,
      `Afuera de la ventana, los pasajeros miraban lo último que habían visto en la pantalla. Justo enfrente de ellos parecían haber enormes ríos y lagos, pero estaban llenos de líquido espeso y viscoso que era negro o anaranjado. De repente, un gran sonido estruendoso sacudió al`,
    ],
    71: [`tren. Máquinas gigantes y enormes camiones aparecieron, moviéndose a través de la tierra vacía. Los camiones y las máquinas eran tan grandes que hacían que el tren pareciera un juguete. Parecían rascacielos sobre ruedas, tapando al sol. La pura llanta de una máquina medía más de treinta pies de altura. El ruido se volvió casi insoportable.`,
      `Entonces el tren se detuvo completamente. Todos miraron a su alrededor, confundidos y congelados. Creamy estaba llorando. “¡No me gusta este lugar!” gritó (era la única manera de ser escuchada). “¿Tenemos que detenernos aquí?”`,
      `“Parece que el tren quiere que nos detengamos aquí,” gritó The Fluff, “tal vez para conocer más animales.”`,
      `Nadie se movió. El cielo afuera de la ventana se volvió más oscuro, y`,
    ],
    72: [`un sonido aún más fuerte sacudió al tren. Todos pusieron aletas, pezuñas, alas, y manos sobre sus oídos. Miraron hacia donde provenía el sonido, más allá de un enorme hoyo en el suelo, y vieron un derrumbe masivo. Pareció durar una hora. Finalmente hubo silencio.`,
      `“Este,” dijo Joanna. “Tenemos visita.”`,
      `Del otro lado del tren, una gran cabeza llenaba la ventana. Era uno de los animales que habían visto desde el aire. Sus ojos estaban azorados, y sus fosas nasales estaban ensanchadas.`,
      `The Fluff fue el primero en salir por la puerta. “¡Vamos!” llamo a los demás.`,
      `“Está bien,” dijo. “Te podemos ayudar. Mi nombre es The Fluff, y estos son mis amigos. Esto se llama tren, y nos lleva a una`,
    ],
    73: [`travesía para ayudar a otros animales. Estas son Creamy y Flora. También hay otros animales en el tren. También tenemos dos niñas humanas, Joanna y Marina. Ellas son buena onda; también están de nuestro lado.”`,
      `“Mi nombre es Lauren, y soy una caribú,” dijo la recién llegada. “¡Y se está poniendo muy peligroso aquí!”`,
      `“¿Cómo puede vivir alguien aquí?” lamentó Creamy. “Es tan sucio y terrible.”`,
      `“Lo siento tanto por ti,” exclamó Flora. “Creí que lo que me había pasado a mí era lo peor, pero ahora…”`,
      `“Todos han perdido a sus padres,” explicó Marina. “Sus tierras también están cambiando para peor. ¿Quieres venir con nosotros para escapar este horrible lugar?”`,
      `“¿A menos de que tengas familia aquí que no quieras dejar?” preguntó Joanna.`,
      `“Mi familia ya está en el lejano norte. Los dejé para iniciar mi propia vida,” dijo Lauren, “pero aquí no se puede vivir.”`,
      `A Marina se le iluminó la cara. “¡Tal vez vimos a tu familia!” exclamó. “Vimos a otros caribú caminando hacia el norte por hermosas tierras.”`,
      `“Si tal vez fue mi manada,” contestó Lauren. “Se mueven mucho ahora que nuestro hábitat está en peligro. Toda esta área era bosque boreal, y lo que nosotros en Canadá llamamos ciénega, que son turberas. Pero entonces la gente de las compañías de energía vino y comenzaron a romperlo para llegar a las arenas petrolíferas que están debajo.”`,
      `“Las arenas petrolíferas son bitumen,” explicó Inoah, “una forma muy viscosa de petróleo. También conocido como asfalto, tradicionalmente usado como brea en las carreteras. Por eso se les llama arenas petrolíferas”.`,
      `“Sea lo que sea,” dijo Lauren cansada, “es algo muy pesado y pegajoso. Para lograr que fluya a una tubería o a un camión, la gente lo bombardea con agua del rio que han calentado. Luego ponen el`,
    ],
    74: [`agua en unos tipo estanques—“`,
      `“¡Estanques de relaves!” entrometió Inoah.`,
      `“—y a veces se fuga a los pequeños arroyos en el pantano, y eventualmente a ese gran rio. Ese es el Athabasca.”`,
      `“No lo entiendo. Parece un terrible desperdicio de tierra,” dijo Edgar.`,
      `“Yo hice un trabajo de ciencias sobre esto,” dijo Marina “Las compañías de energía afirman que la restaurarán cuando hayan terminado.”`,
      `“Pero no es posible que restauren la ciénega,” dijo Lauren tristemente. “Tarda miles de años para desarrollarse de plantas que se descomponen lentamente como el musgo, que es lo que yo como. Lo van a reemplazar con pequeñas lomas y estanques de mentiras.”`,
      `“Suena muy parecido al cuarto en el que vivo en el zoológico,” dijo Creamy.`,
      `“¡No deberían estar haciendo esto!” dijo Marina enojada. “Esto no es el zoológico. ¡Esto es la naturaleza! No deberíamos ni siquiera estar quemando el petróleo que van a obtener de esto, porque producirá demasiado CO2. No solo eso, mi investigación mostró que cuando excavan las turberas, sueltan toneladas de CO2 directamente al aire.”`,
      `“CO2 de nuevo.” dijo Joanna.`,
      `“El tren ha estado detenido aquí por mucho tiempo,” notó de pronto Flora.`,
      `“Necesitamos seguir siendo positivos para que se empiece a mover de nuevo,” dijo The Fluff.`,
    ],
    75: [`“¿Cómo podemos seguir siendo positivos” exclamó Creamy, “cuando sabemos que tanto anda mal? ¡Este lugar de las arenas petrolíferas es absolutamente horrible!”`,
      `“Pues,” observó The Fluff tranquilamente, “mira lo que ya hemos logrado. ¡Todos hemos viajado miles de millas para llegar aquí, y ahora tenemos a este tren para ayudarnos!”`,
      `“Y nos ha reunido,” agregó Flora. “Juntos, podemos lograr…”`,
    ],
    76: [`“¡Cualquier cosa!” dijo Sally. “¡Creamy, sí podemos ayudar a todos los animales del mundo! ¡Así como tú quieres!”`,
      `“Pues, yo sé que me han ayudado a mí,” dijo Tomás.`,
      `“Y a mí,” dijo Edgar.`,
      `“Llegaron por mí en el momento justo,” dijo Lauren.`,
      `Los animales se sonrieron los unos a los otros. Joanna, quien sostenía a Sally, miró a Marina. “Pero no entiendo qué hacemos nosotras aquí,” dijo ella. “Ustedes han pasado todos por tantas dificultades y nosotras no. ¡Somos personas, y las personas ha causado todo el problema!”`,
      `“Es nuestra culpa,” coincidió Marina. “La gente ha sido estúpida. Increíblemente estúpida. Realmente ya no sé qué estamos haciendo en este tren.”`,
      `Usualmente ella no se daba por vencida, y los animales se preocuparon mientras Marina se alejaba caminando con la cabeza baja. Todo estaba callado. Un pequeño pájaro amarillo aleteaba contra la ventana, pero nadie se dio cuenta.`,
      `“¡Yo sé que están haciendo aquí!” chilló Sally de repente. Ella señaló a Joanna para que la levantara en alto y que los demás la pudieran escuchar. “Ustedes nos escuchan, Nos apoyan. ¡Nos ayudan!”`,
      `“Sí,” dijo The Fluff. “Yo sabía cuando dejé mi hogar que tendría que encontrar humanos y aprender a confiar en ellos. De los que conocí en Antártida, podía ver que estaban a cargo—bueno, tal vez no a cargo, pero eran más poderosos que los animales.”`,
      `“Y sabíamos que necesitábamos ayuda, y llegó el tren, y luego nos llevó a ustedes dos,” dijo Creamy.`,
      `“Y ustedes van a su gran líder,” dijo Flora. “Ustedes nos encontrarán la ayuda que necesitamos.”`,
    ],
    77: [`Hasta a Inoah se le salió un graznido reconfortante, “¡Si!” Entonces se tapó el pico con sus alas. Se había sorprendido a si misma con su arrebato emocional.`,
      `Marina miro a sus amigos. “No veo cómo va a funcionar esto, pero si ustedes creen que hay esperanza, después de todo lo que han pasado, entonces creo que debemos ver a donde nos lleva esta travesía.” Todos la miraron y se miraron entre ellos, y uno por uno se subieron de nuevo al tren. Burbujas comenzaron a llenar el aire de nuevo. El tren comenzó a moverse, lentamente al principio, y luego fue agarrando velocidad.`,
      `De pronto Flora brincó. “¡Ey! ¿En dónde está Creamy?”`,
      `Todos miraron por las ventanas. Creamy corría hacia ellos.`,
      `“¡Las focas no pueden correr rápido con sus aletas!” exclamó Flora. Ella`,
    ],
    78: [`empujó para abrir la puerta, bajó del tren de un salto, y tomó a Creamy en sus brazos. Entonces con sus piernas fuertes, comenzó a correr hacia el tren.`,
      `“¡No lo van a lograr!” chilló Sally.`,
      `The Fluff tuvo una idea. “¡Ey!” gritó. “¡Si nos ponemos tristes, el tren irá más despacio!”`,
      `Todos comenzaron a llorar— al principio de mentiras y luego de verdad al pensar en perder a todos sus amigos. El tren se detuvo rechinando, completamente inmóvil. Flora se subió, aun cargando a Creamy.`,
      `Creamy estaba asustada y sintiendo alivio. Flora estaba sofocada. Todos estaban muy felices.`,
      `“¡Muchas gracias, Flora! ¡Me salvaste! Me hubiera quedado atrás. ¡Eres increíble!” dijo Creamy.`,
      `Flora la abrazó.`,
      `Una vez más, ahora que todos estaban tan felices, comenzaron a salir burbujas de la chimenea, y el tren comenzó a tomar velocidad. Flora y Creamy se sentaron juntas.`,
      `“Esa es una extraña amistad,” observó Edgar. “Pero desde que estoy en este tren, han pasado cosas bastante raras.”`,
      `El resto de los animales se fueron a alistarse para dormir. Al caer la noche, sabían que aún iban por el campo porque no había luces. Pronto, podían escuchar agua corriendo afuera, aún más fuerte que el traqueteo de las ruedas del tren.`,
    ],
    79: [
      `“Estamos siguiendo el Río Athabasca,” dijo Lauren adormilada. “Es un gran río del cual depende mi manada para el agua. Fluye hacia el norte. Creo”—bostezó—“que nosotros también vamos hacia el norte.”`,
      `Uno por uno, todos se acomodaron para dormir. Había sido un día largo. Solo The Fluff continúo mirando pensativamente por la ventana, su barbilla en su aleta, escuchando el sonido del agua que corría.`,
    ],
    80: [`Lady Athabasca`,
      `Estaba callado cuando las niñas y los animales se despertaron al amanecer. Lauren dijo, “Creo que nos acercamos a la boca del Rio Athabasca, el Delta Peace-Athabasca—“`,
      `“¡El delta de agua dulce interior más grande del mundo!” anuncio Inoah.`,
      `“Este es el Parque Nacional Wood Buffalo,” continuó Lauren, ignorando al perico. “Aquí no se permiten máquinas. Es una reserva para los bisontes y la grulla blanca—“`,
      `“Quienes casi estuvieron en extinción,” agregó Inoah.`,
      `“Este es su único hábitat natural para anidar, pero con ayuda de los humanos—mucha ayuda—han podido adaptarse a otros lugares protegidos,” dijo Lauren. “Su hogar de invierno en la costa del Golfo de Texas también es un refugio.”`,
    ],
    81: [`El tren se detuvo de pronto, justo a tiempo para evitar atropellar a una gran ave blanca que atravesaba pavoneándose las vías, con una boa azul y un sombrero morado con plumas. Les saludó amablemente con una larga ala.`,
      `“¡Ocho pies!” graznó Inoah. “¡Eso es lo que miden sus alas de punta a punta!”`,
      `“Como diez veces más que las tuyas,” dijo Flora secamente.`,
      `Entonces Flora llamó desde la ventana: “Usted es una grulla blanca, que no, señora?” El ave se veía sorprendida de que un oso polar se dirigiera a ella.`,
      `The Fluff fue hacia la puerta del tren y la abrió. “¡Hola! Justo hablábamos de usted, o bueno, de su gente, o, este, sus aves. Entre—digo, pase.”`,
    ],
    82: [
      `La grulla rechazó su invitación amablemente. Así que The Fluff bajó mientras que los otros animales miraban, y se paseó con la gran ave.`,
      `Mientras que la grulla hablaba, The Fluff hacía su mejor esfuerzo para seguir con los tremendos pasos del ave. Creamy se reía. Eventualmente, las dos aves se dieron el ala--o bueno, el ala y la aleta—y The Fluff volvió a bordo.`,
      `“¿Y bien? ¿Qué dijo?” preguntó Creamy.`,
      `“Se los diré pronto,” contestó The Fluff, “pero ahorita la tenemos que seguir. Su nombre es Lady Athabasca. Le conté sobre nuestra travesía. Ella se unirá a su parvada migratoria con otras diecinueve grullas que se dirigen al sur. Necesitamos seguirles cuidadosamente, porque tienen algo que mostrarnos.”`,
      `“¡Pero su migración toma como dos o tres semanas!” exclamó Inoah.`,
      `“No creo que podamos tomar tres semanas más,” dijo Marina. “Mejor dile que no podemos ir.”`,
      `“¿Qué tal si en lugar las subimos al tren, y así podemos llegar en un par de horas?” preguntó Flora.`,
      `“¿Este, Flora? Realmente no veo como podamos meter veinte aves con alas de ocho pies en este tren,” dijo Tomás frunciendo el ceño.`,
      `“¡Yo sé! ¡Yo sé! ¡Yo sé!” chilló Sally. Estaba tan emocionada que brincaba muy alto en el aire.`,
      `“¿Cómo hace eso?” preguntó Edgar.`,
      `“¿Qué pasa Sally?” pregunto Joanna, cargándola y sosteniéndola para que todos la pudieran escuchar.`,
      `Sally estaba sin aliento de tanto brincar. “Pongan (uf uf) …las (uf uf) en … (uf uf uf uf uf uf…)”`,
      `“¿En qué?” interrumpió Flora. “¿Sally, qué estás tratando de decir?”`,
    ],
    83: [
      `“¡Encima del tren!” Sally logró chillar, frunciendo sus minúsculas cejas a Flora.`,
      `“Encima del tren…,” repitieron todos, mirándose los unos a los otros.`,
      `“Bien,” dijo The Fluff. “Ellas pueden decirle al tren a donde ir y simplemente montarse arriba en el techo.”`,
      `“Y todos sabemos que el tren puede ir tan rápido como quiera,” dijo Marina.`,
      `“¡Especialmente cuando nos sentimos felices y positivos!” agregó Creamy.`,
      `“¡Gran idea Sally!” dijo Tomás mientras le daba un pequeño chócala versión salamandra.`,
      `Marina salió a explicarle la idea a la enorme ave. Todos miraban mientras Lady Athabasca se iba a hablar con su parvada. Cuando regresó, las niñas y los animales salieron todos del tren. Alzaron sus miradas mientras que primero Lady Athabasca, y luego diecinueve enormes aves más, aterrizaban ligeramente en el techo del tren. Luego se acomodaron sentándose en posición como si todas estuvieran empollando.`,
    ],
    84: [
      `“¡Ey, si nos vamos a estar moviendo rápido, van a necesitar cinturones de seguridad!” dijo Tomás. Justo en ese momento, los cinturones aparecieron mágicamente sobre la espalda de cada grulla y se sujetaron al techo.`,
      `Lady Athabasca los miró a todos bajando la mirada a lo largo de su gran nariz—o más bien, pico. “Esta es una circunstancia muy inusual, pero…estamos listas,” anunció.`,
      `Al decir esto, el tren avanzó dando un tirón, y todos los demás se amontonaron a bordo mientras aceleraba. Lauren saco una pezuña y jaló a The Fluff quien fue el último.`,
      `“¡Guau!” exclamó,” ¡Así es como se debe sentir volar!”`,
      `“¡Necesitamos un tragaluz para verlas!” dijo Tomás. “¡Nunca he visto grullas volar sin volar!”`,
      `“Nunca has visto grullas, Tomás,” le recordó Sally.`,
    ],
    85: [`Apareció un tragaluz del tamaño de todo el techo. Arriba, las grullas platicaban como si hicieran esto todos los días.`,
      `“Bueno, creo que esta será la migración más fácil que jamás hayan hecho,” dijo Edgar.`,
    ],
    86: [
      `La Costa del Golfo`,
      `Mientras que los animales se acomodaban para el viaje, el tren comenzó a moverse con mucha velocidad. Flora se dio cuenta de que de pronto el piso del vagón también se había vuelto transparente. Miró a la tierra pasando por debajo, como si la mirara a través de hielo. “¡Miren, todos!,” gritó. “¡Podemos ver el suelo!”`,
      `Todos miraron hacia abajo y luego más allá del tren, hacia grandes tuberías que atravesaban la tierra.`,
    ],
    87:[
      `“Parecen miles de juguetes,” observó Joanna.`,
      `“Sí, pero son reales,” contestó Marina, “y mucho más peligrosos que los juguetes. ¡Traen petróleo a los puertos de la costa del Golfo, y de ahí, es enviado a todo el mundo a ser quemado! Estudié todo sobre eso.”`,
      `“Lady Athabasca me contó todo sobre esto,” dijo The Fluff. “Se llama el sistema de oleoductos Keystone. Las grullas vuelan sobre él dos veces al año cuando emigran, así que lo conocen bien. Ella dijo que a veces se rompen las tuberías y derraman petróleo a la tierra, arroyos, y lagos. Es especialmente peligroso para Lady Athabasca y otras aves acuáticas, porque si les cae petróleo no pueden nadar o conservar calor, y se mueren.” Bajó la mirada tristemente.`,
    ],
    88: [
      `El tren siguió a una de las grandes tuberías hacia lo que parecía una enorme fábrica, echando humo.`,
      `“¿Qué es eso?” preguntó Flora.`,
      `“Es una refinería,” explicó Marina. “Es en donde el petróleo crudo se convierte en gasolina para carros, y otras cosas.”`,
      `“¿Y tiene que ver con…quemar?” preguntó Creamy.`,
      `“Sí,” graznó Inoah. “Tienen que calentar el petróleo hasta 400 grados.”`,
      `“Fahrenheit,” agregó Joanna.`,
      `“¿Qué jeit?” preguntó Flora.`,
      `Justo en ese momento, la pantalla se desenrolló para mostrarles imágenes de petróleo siendo quemado por todo el país, creando una nube de CO2 y metano que parecía llenar todo el aire hasta llegar al espacio.`,
      `“¿Ven?” dijo Marina. “Por eso no hay tiempo que perder. Tenemos que convencer al presidente de que detenga todo esto. ¡Ahora! No hay lugar para nada más de esto.”`,
    ],
    89:[
      `“Sí, pero ahora nos dirigimos hacia el sur, no hacia el este,” indicó Flora.`,
      `Solo habían estado viajando una hora, pero podían ver a través del fondo del tren que ahora pasaban sobre arena. Por la ventana, mientras que el tren reducía su velocidad, la vista era de una costa que se aproximaba.`,
      `“Este debe ser el golfo de la costa de Texas, a donde emigran las aves en el invierno,” dijo Joanna.`,
      `En un momento, el tren se detuvo en una hermosa playa. Era el atardecer.`,
      `Los cinturones de seguridad desaparecieron en el aire, y las grullas se levantaron elegantemente, se estiraron, y volaron al agua para beber y pescar. Los otros animales las siguieron.`,
      `“Oh, que hermoso,” dijo Marina. “¡Las playas son mi lugar favorito!”`,
      `Todos miraban la escena tranquila de una parvada de grullas blancas vadeando por el agua.`,
      `“¡Nademos!” dijo Flora.`,
      `Todos los que podían nadar, lo hicieron. Creamy, Flora, y The Fluff se divirtieron tanto que no querían salir del agua. Al caer la noche en el golfo, fueron los últimos en volver a la costa.`,
      `“¡Eso fue perfecto!” dijo The Fluff. “Aun siendo un poco tibio para mi gusto.”`,
      `“Miren,” dijo Joanna. “Las grullas quieren que las sigamos.”`,
      `En la semi oscuridad, las grullas se habían salido del mar y les hacían señas con sus alas. Lady Athabasca aterrizó y explicó, “Si nos apuramos, les podemos mostrar algo más que les queríamos enseñar.”`,
      `Empezó a saltar con sus largas piernas y recogió a Sally en sus alas. Todos corrieron hacia ella. Algunos de los animales eran muy rápidos. Marina y Joanna montaban en Tomas y Flora, mientras que Creamy y The`,
    ],
    90:[`Fluff se fueron de aventón sobre Lauren.`,
      `“¡Estás erizando mis plumas!” gritó Inoah desde el hombro de Joanna, deteniendo su sombrero de paja.`,
      `Unos minutos después, se reunían con las grullas a la orilla del golfo que se oscurecía. La luna llena brillaba sobre las olas, excepto en lugares en donde el agua era completamente oscura.`,
    ],
    91:[`Lauren se sorprendió. “¿Ey, qué es eso en el agua? ¡Lo he visto antes! Una vez hasta tomé algo por accidente. ¡No me digan que esto es igual que las arenas petrolíferas!”`,
      `“Pues, sí, lo es, más o menos. Ese es el problema,” dijo Lady Athabasca “Esto es lo que queríamos que vieran. Esto es petróleo, vertido por un enorme derrame petrolero. Tres millones de galones de petróleo. Vino de la explosión de una plataforma petrolera del mar llamada Deepwater Horizon. Ha matado a muchos seres, incluyendo algunos humanos.”`,
      `“¿Petróleo de nuevo?” preguntó Lauren decepcionado. “Creí que me estaba alejando del petróleo.”`,
      `La luna se escondió tras las nubes, y la noche era completamente oscura. Los animales, quienes habían estado alegres—al menos por un rato—`,
    ],
    92:[
      `ahora caminaban tristemente hacia el tren. Solo The Fluff se quedó atrás. Ver como el océano era afectado aquí, le recordó a su hogar en peligro.`,
      `“Primero, el plástico, luego el hielo que se derrite, y ahora el petróleo,” dijo en voz alta. “Si iba a haber un momento indicado para detener todo esto, es ahora. ¡Debo decirle a Marina que tenemos que llegar a su presidente inmediatamente! ¡Necesitamos decirle que todo esto es debido a esas cosas llamadas combustibles fósiles! Todo es por culpa de ellos! ¡Él tiene que ayudar!”`,
      `“Pues, no me caería mal algo de ayuda,” contestó una pequeña voz. Mirando hacia abajo por donde venía el sonido, The Fluff vió a un diminuto pato verde y café iluminado en la luz de la luna, meciéndose en las suaves olas que llegaban a la costa.`,
      `The Fluff se agachó para ver a la pequeña criatura, quien lo volteaba a ver con alivio.`,
      `“¡Zolo! ¡Mi nombre es Zolo! Tu eres el pato mas grande y gigantesco que he visto en toda mi vida! ¿Viniste a rescatarme? ¡Mi familia ha desaparecido! ¡No me queda nadie! ¡Aún hay petróleo en mis plumas o me iría a donde vive mi abuela! ¿Me puedes ayudar? ¿Cómo te llamas? ¿De dónde viniste? ¿También estás cubierto en petróleo? ¿Y por qué es tan largo tu pico?” dijo el pequeño en un solo aliento. Luego, terminando su pensamiento, agregó, “Me gusta mucho tu sombrero.”`,
      `Sonriendo, The Fluff no dijo nada. Levantó cuidadosamente al diminuto patito y se sentó, deteniéndolo en su aleta. Pronto, el pequeño estaba dormido, pero The Fluff se quedó despierto por mucho tiempo, mirando contemplativamente hacia el mar.`,
      `La próxima mañana, uno por uno, Marina, Joanna, Tomas, y Sally se dirigieron a la caleta. (Creamy y Flora no pudieron resistir una nadada más, y habían estado mar adentro durante horas.) En su camino hacia la caleta, las niñas y los animales se toparon a The Fluff caminando hacia ellos. Parecía que hablaba consigo mismo. Pero mientras se acercaba,`,
    ],
    93: [`se dieron cuenta que hablaba con un pequeño ser que caminaba a su lado.`,
      `“No lo dejen que empiece a hablar,” les advirtió The Fluff en voz baja al reunirse todos. “¡Nunca para de hablar!”`,
      `De pronto, un silbido sonó más allá de la playa. ¡El tren, de propia voluntad, se empezaba a mover sin ellos! Como relámpago salieron del agua el oso polar y la foca. Todos los demás corrieron para alcanzar al tren. Joanna fue la ultima en saltar a bordo. Se volteo para ver a las grullas, todas paradas en el oleaje poco profundo. Lady Athabasca levanto un ala, y de pronto, todas las veinte grullas alzaron sus alas como en un saludo. “¡Adiós!” dijo Lady Athabasca. “Ahora que ya saben de esto, podrán ayudar a encontrar la solución para todas las aves acuáticas. ¡Pobrecitas! ¡Buena suerte!”`,
      `“¡Buena suerte a ti!” gritó Joanna. Con una lagrima en sus ojos, se trepó al tren en movimiento.`,
    ],
    94:[
      `A bordo, los demás miraban a las grullas y a la playa desaparecer en la distancia.`,
      `“Fue muy bonito estar en el mar de nuevo,” dijo Creamy con nostalgia. Ella miró a Flora quien miró a The Fluff. Pero The Fluff estaba ocupado. Estaba ayudando al pequeño patito a quitarse lo que parecía ser un vendaje muy viejo, y muy sucio.`,
      `“¿Qué te pasó?” preguntó Flora.`,
      `“Oh, no es nada,” respondió el pequeño pato joyuyo. “Esto es solo una herida vieja y algo de petróleo seco. A mi familia le fue mucho peor. ¡Yo no estaba con ellos en donde nadaban cuando el petróleo llegó tan rápido! Todos murieron en la explosión que su amiga, el ave grande, platicó.”`,
      `“Que terrible,” dijo Flora. “Se lo que se siente. Yo también perdí a mis padres.”`,
      `“¡Yo no vi a la cosa grande explotar, pero lo escuché!” continuó el pato. “Estaba nadando, me sumergí, y cuando salí a respirar, no podía ver. Todo lo que recuerdo después de eso es oscuridad. Luego, cuando desperté, estaba en un pequeño cuarto de vidrio con otros pocos patos joyuyos. También había personas ahí. Miré alrededor buscando a mis padres, pero no estaban ahí. Escuche a un humano decir que solo había un pato que había sobrevivido de esa área. ¡Entonces me di cuenta de que estaban hablando de mí, y que mi familia ya no vivía, y me abrumó la tristeza! Lloré y lloré. Todavía estoy triste. ¡Pero ahora soy mucho mayor! Ya tengo dos años—¡prácticamente soy un adulto! Bueno, no me veo tan grande, porque soy pequeño para mi edad, ¡pero me puedo cuidar solo! Solo no sé cómo me voy a quitar toda esta cosa negra de mis alas. ¡Trato y trato, pero está pegada!”`,
      `“Zolo,” dijo The Fluff. “Déjame mostrarte el lugar.” Zolo brincó de su asiento felizmente para seguir a su nuevo “hermano mayor”. Todos se miraron los unos a los otros.`,
      `“Me da lástima ese patito, pero vaya cómo habla,” dijo Edgar`,
    ],
    95:[
      `Acorn Creek`,
      `Dos días después, el tren rodaba a través de frondosos campos verdes de pasto, y luego colinas densamente boscosas. Las niñas y los animales miraban por las ventanas barrancos profundos con caudalosos ríos.`,
      `Mientras que comenzaban a subir, Tomás tomó un respiro profundo y suspiró, “Montañas.”`,
      `Justo en ese momento, pasaron una curva cerrada, y ante ellos vieron lo que parecía ser un gigante arenero lleno de camiones.`,
      `“¿Qué pasa aquí? En donde quedó la montaña?” preguntó Tomás.`,
    ],
    96:[

      	`“Eso es una mina de carbón,” dijo Marina. “Antes el carbón se excavaba de profundos túneles dentro de montañas, pero ahora, las compañías de energía simplemente cortan las cimas enteras de las montañas para llegar al carbón.”`
    ],
    97: [
      `“¿Cortar las cimas de las montañas?” chilló Sally.`,
      `“¿Cómo pueden hacer eso?”`,
      `Tomás exclamó. “Si cortaran mi montaña, destruirían todos los hogares que mi familia ha hecho, desde mis tatarabuelos. ¡Mi montaña ha sido nuestro hogar por mucho, mucho tiempo!”`,
      `En el fondo de una hondonada, el tren se detuvo rechinando, y todos casi salieron volando por las ventanas.`,
      `“Cielos, eso fue repentino. ¡Que aterrizaje tan brusco!” comentó Joanna mientras se paraba mareada. “Supongo que es mejor que veamos por qué nos hemos detenido.”`,
      `Tomás y Sally ya estaban afuera, asomándose a un arroyo. Era`,
    ],
    98:[
      `de un extraño color anaranjado rojizo. Los demás se amontonaron alrededor.`,
      `“Fuchi,” dijo Lauren. “Ese es el mismo color del agua de donde yo vivía.”`,
      `“¡Oh, vean a los pobres pececillos! Están tan quietos. Por qué no nadan?” dijo Tomás. Él quería recogerlos con su pata, pero no los quería asustar.`,
      `A unos pies río abajo, el grupo vio a un pez con vestido de verano, sombrero, y parasol.`,
      `Sally corrió para hablar con ella. “¿Cómo te llamas?” preguntó.`,
      `El pez dejó de nadar y miró a la salamandra. “¡Buenos días a todos ustedes! Bienvenidos a Acorn Creek,” dijo con acento sureño. “Mi nombre es Bobbi Sue Sunfish. ¿Les ofrezco algo de comer?” ella apuntó hacia las hierbas del rio. “Disculpen si es un poco amargo. Me dicen que a eso se le llama ‘tóxico.’”`,
      `“¿Tóxico? ¿Estás bien?” preguntó Tomás con preocupación.`,
      `“¿Parece que estoy bien?” estalló Bobbie Sue. “¡Claro que no estoy bien! ¡Mira esta agua! ¡Míralos a ellos!” Apuntó su parasol hacia los pececillos inmóviles.`,
      `“Este… ¡lo siento! Por cierto, soy Tomás,” le dijo él.`,
      `“Y yo soy Sally,” dijo la salamandra. “Llegamos aquí en un tren mágico que nos lleva de lugar a lugar en donde hay problemas con la tierra.”`,
      `“Y el agua,” agregó Tomás.`,
      `“Y el aire,” dijo Sally. “¡Parece que hay problemas a donde miremos!”`,
      `“Estos son nuestros amigos,” dijo ella, mientras que los demás se reunían a su alrededor. “Todos nos unimos al tren. Nos dirigimos a Washington D.C., a decirle al señor presidente de los Estados Unidos sobre los problemas que estamos teniendo debido a—“`,
      `“¡El cambio climático y la contaminación!” añadió Inoah.`,
    ],
    99:[
      `“Por cierto,” preguntó Edgar, “¿Por qué esta agua es rosa?”`,
      `“El agua es rosa porque alguien vació algo llamado fluido de fracking en mi arroyo,” dijo Bobbi Sue.`,
      `“Oh cielos,” dijo Creamy. “Qué horrible.”`,
      `“Sí, ¿pero qué es fracking?” preguntó Edgar.`,
      `“Sucede cuando las personas usan demasiada agua para empujar químicos en las profundidades del suelo con fin de obtener el repulsivo petróleo, y cuando el agua sube de nuevo, ¡regresa al arroyo toda roja y asquerosa!” dijo Bobbi Sue. “¡Todo para ganar dinero!”`,
      `“Espera … ¿entonces obtienen dinero del suelo?” chilló Sally.`,
      `Inoah suspiró fuertemente. “No, no, no,” graznó. “¡Incorrecto!”—y luego agregó en voz baja, “¿Por qué tengo que explicar todo?”`,
      `Joanna movió a Inoah de su hombro al suelo, pero el pájaro simplemente esponjó sus plumas y continuó: “El fracking hidráulico es un proceso mediante el cual las compañías de energía inyectan agua y químicos en el suelo, bajo gran presión, para forzar al gas natural—o metano—fuera de la roca.”`,
      `“Oh, ¿Para poderlo vender por dinero?” preguntó Bobbi Sue.`,
      `“¡Correcto!” dijo Inoah.`,
      `“¿Pero qué son estos químicos?” agregó Edgar.`,
      `“¡Eso, mi amigo, es un secreto!” graznó Inoah.`,
    ],
    100:[
      `“Pues sea lo que sea, nos está enfermando mucho a mí y a mis amigos,” dijo Bobbi Sue. “Este rio era antes lo que llamábamos un ‘recurso de agua sobresaliente’. Eso significa que era el más limpio del estado. Mi mamá y mi papá siempre estuvieron muy orgullosos de que viviéramos aquí. Tuvimos mucha suerte de que las minas de carbón no contaminaran el agua.”`,
      `The Fluff pensó por un momento, “¿Bobbi Sue,” le preguntó, “te gustaría venir a bordo con nosotros y ayudarnos? Todos tenemos historias como la tuya, y nos serviría tenerte para poder contar más historias.”`,
      `“Pues, siempre y cuando este señor de Washington pueda ayudar a mi arroyo, ¡cuenten conmigo!” declaró mientras le pasaba su parasol.`,
    ],
    101:[
      `“¡Tengo una idea!” dijo Zolo mientras corría dando vueltas y luego dentro del tren. Momentos después, regresó jadeando. “¡Le acabo de pedir al tren que haga una alberca de agua fresca, y lo hizo! Así que, Bobbi Sue, si te gustaría unirte a nosotros, tenemos un lugar para que te quedes.”`,
      `Creamy agitó animadamente su aleta en el aire y dijo, “Deberíamos hacer una barra de comida al lado de la alberca para que Bobbi Sue pueda tener comida cuando quiera.”`,
      `“¡Oooo oooo!” dijo Zolo. “¡Todos podemos usar la alberca también! Bueno, a los que nos gusta nadar,” agregó rápidamente, mirando a Edgar.`,
      `“Me imagino que ya se está haciendo tarde,” dijo Edgar, “y deberíamos volver a subir al tren.”`,
      `Los animales asintieron y subieron a bordo.`,
      `Tomás sonrió al pez. “Bueno, Bobbi Sue, ahora te voy a recoger`,
    ],
    102:[`para cargarte. Okey?”`,
      `“Está bien,” dijo ella, “pero ten cuidado con esas garras.”`,
      `Momentos después, mientras Bobbi Sue nadaba en su nueva alberca, ella vio a The Fluff, Flora, Zolo, Creamy, Joanna, y a Marina acercarse a la orilla.`,
      `“¿Esta bien si nadamos contigo?” preguntó Flora.`,
      `“Siempre y cuando observen sus modales y no me coman,” contestó Bobbi Sue.`,
      `Los animales asintieron solemnemente. Zolo fue el primero en entrar, salpicando mientras que Bobbi Sue se zambulló para quitarse de su camino.`,
      `Mientras tanto en el vagón, Edgar y Tomás se sentaban juntos. Tomás hizo señas a Edgar al ver a un pequeño pájaro amarillo volar tras la ventana. Comenzaron a adormecerse.`,
    ],
    103:[],
    104:[`La Ciudad de Nueva York`,
      `Mientras que el tren se aceleraba por el campo, Marina estaba feliz de ver algunos conjuntos de paneles solares, pero también había muchos pozos de fracking.`,
      `Se recargó en su asiento y suspiró, “Tenemos que llegar al presidente, y pronto.”`,
      `Con ese pensamiento, el tren comenzó a moverse tan rápido que la vista por la ventana se hizo borrosa.`,
      `En menos de una hora, todos los que estaban a bordo podían ver la silueta de una ciudad. El tren comenzó a bajar de velocidad.`,
      `“¡Oh, miren!” exclamó Joanna, “¡Creo que nos dirigimos a la ciudad de Nueva York!”`,
    ],
    105:[
      `“¡Bueno, ya que estamos aquí, echemos un vistazo!” agregó Marina con emoción.`,
      `“Okey,” dijo The Fluff, “¡Hagámoslo!”`,
      `Las niñas y los animales tuvieron una cena de día de campo en el Parque Central, y luego, a recomendación de Flora, fueron a la obra musical de Broadway de El Rey León. Saliendo de la obra en Times Square, se detuvieron a ver a artistas callejeros bailando y haciendo acrobacias en el centro de la plaza.`,
      `Sally no estaba impresionada. “No veo por qué la gente les está dando dinero. Yo fácilmente puedo hacer eso con los ojos cerrados. ¡Miren!”`,
      `Hizo una maroma en la mano de Marina.`,
      `“Espera,” dijo Joanna. “Voy por algo para que la gente te pueda ver.”`,
      `Se dirigió a una caja abandonada recargada en un parquímetro. Al levantar el cartón polvoriento, vio a una figura oscura debajo de él.`,
      `“¡Iiiiiiiiiiiiii! ¡Una rata!” gritó.`,
      `Parada en sus patas traseras, la rata se veía indiferente, tranquila, y`,
    ],
    106:[`serena. Vestía camisa y pantalones tie-dye con un símbolo de paz grande en la pierna izquierda. Tenía rastas que le llegaban a los hombros, y en una oreja picuda un solo arete dorado.`,
      `“¿Por qué tanto escándalo amiga? Pareciera que nunca habías visto una rata. Híjole,” dijo la rata, cruzando sus brazos y frunciendo el ceño impacientemente, y dándole un vistazo a Joanna. “¡Te pasas! Me has quitado mi escondite perfecto, cuidadosamente ubicado en medio de toda esta comida de humanos. Exijo que lo remplaces inmediatamente, y que me des del pretzel que tienes en tu mano como recompensa por la molestia.”`,
      `Anonadada, Joanna rápidamente le dio la mitad de su gigantesco pretzel, murmurando una disculpa.`,
      `“Gracias,” dijo la rata. “Por cierto, me llamo Zingo. ¿Y quienes son tú y este zoológico ambulante?”`,
      `“¡Ey!” dijo Creamy. “¡No somos un zoológico!”`,
    ],
    107:[
      `“Sí,” dijo Edgar, “¡y somos mucho más grandes que tú!”`,
      `“Pues lo serás tú,” chilló Sally. “¡Pero arruinaste mi espectáculo!”`,
      `“¿Espectáculo?” Zingo resopló. “¿Qué hacen aquí para empezar?”`,
      `“Estamos aquí porque el calentamiento global amenaza a todos nuestros hogares, y queremos hablar con el presidente sobre eso,” dijo Flora.`,
      `“Esta es Flora,” dijo Tomás. “Yo soy Tomás, y esta es mi mejor amiga Sally, y estos son Lauren, Creamy, Edgar, Marina, The Fluff, Joanna, y—“`,
      `“¡Hola! ¡Soy Zolo!”`,
      `El patito corrió entusiasmado hacia Zingo. “Soy un pato joyuyo. ¡Tengo dos años! Te ves raro. ¡Oh mira! ¡Siento que por fin soy más grande que alguien! Excepto Sally, por supuesto. Ella es una salamandra. Llegamos aquí en un tren mágico. Nos tomó mucho tiempo para llegar aquí desde Texas. ¿No es increíble? The Fluff y Creamy comenzaron en San Diego. Creo que eso es muy padre. ¿Y qué tal tu? ¿En dónde vives? ¿Quieres unirte a nosotros en el tren? Me gusta tu camisa. ¿Sabes en donde puedo conseguir una igual? ¿Hay algún lugar para ir a nadar por aquí?”`,
      `¡Puuum! El estruendo de un trueno llenó el cielo. En segundos, el grupo entero estaba empapado mientras caía un chapuzón. La gente corría para resguardarse, llamando a taxis, y subiéndose a autobuses.`,
      `Zingo se hizo cargo. “¡Síganme! Tengo un gran lugar para esperar a que termine la tormenta.”`,
      `Los animales y las niñas lo siguieron corriendo. Zingo los llevó a un callejón entre dos restaurantes en donde una salida de incendios que estaba arriba los protegía.`,
      `Zingo frunció el ceño y miró hacia el cielo. “Jmmmm,” dijo. “Esto no es bueno. ¿Sienten el aire? Algo está pasando. No creo`,
    ],
    108:[`que este clima termine pronto.”`,
      `“¡Sí, se siente igual que cuando viene una gran tormenta de nieve!” dijo Flora.`,
      `Los animales asintieron en acuerdo y comenzaron a hablar todos al mismo tiempo.`,
      `Zolo interrumpió: “No sé qué es nieve, pero sí sé de tormentas! Una vez cuando yo—“`,
      `The Fluff lo cargó rápidamente, aun hablando, y le tapó la boca con su aleta.`,
      `“Tenemos que volver al tren,” gritó Marina.`,
      `Otro trueno retumbó entre los edificios de Times Square. Mientras que el cielo se iluminaba con relámpagos, un vehículo apareció delante de ellos, bañado de lluvia pero rodeado de burbujas y mariposas.`,
      `¡Era el tren!`,
      `“Wow…que padre. Qué tren,” dijo Zingo con aprobación.`,
    ],
    109:[
      `“¡Vámonos!” gritó Marina.`,
      `“¿Vámonos?” dijo Zingo. “¿En esto? ¡Niiice! Esto es hasta mejor que las combis que tenían en los 60s.”`,
      `El los siguió con ojos brillantes mientras todos subían a bordo.`,
    ],
    110:[`La Tormenta`,
      `Para la medianoche, la tormenta era furiosa. El tren se mecía de lado a lado como un barco en alta mar.`,
      `“¡Sujétense todos!” gritó The Fluff.`,
    ],
    111:[
      `De repente, comenzaron a suceder cosas malas por toda`
    ],
    112:[`la Gran Manzana. Se fue la luz en la parte baja de Manhattan; vientos de 140 mph tiraron faroles, tumbaron postes de electricidad, y arrancaron arboles; torrenciales de lluvia inundaron techos y toldos. Pero lo peor era el océano.`,
      `El Tren del Calentamiento Global se aceleraba hacia la parte sur de la isla de Manhattan. En menos de un minuto, el tren había llegado a Battery Park, en donde el agua del mar entraba a chorros. Inmediatamente, un enorme muro de agua surgió sobre el tren, deteniéndolo por completo. Pero en vez de ser inundado, el tren simplemente…flotó!`,
      `Todos los animales se sentaron en el piso impresionados. Marina y Joanna se paraban asomándose por las ventanas hacia el cielo oscuro, tratando de ver que sucedía.`,
      `Sally fue la primera en hablar. “¿Qué está pasando?” preguntó.`,
      `Zolo subió de un brinco a un asiento y comenzó a bailar mientras decía: “¡Guau! Esto es increíble y maravilloso. ¡Me encanta esto! ¿En dónde estamos? ¡Guau! ¡Tanta agua!”`,
      `The Fluff lo apaciguó sosteniéndolo en su asiento. “Zolo, estamos en medio de una tremenda tormenta. Yo que tú, no estaría bailando,” dijo The Fluff mientras le ponía a Zolo su cinturón de seguridad firmemente.`,
      `Justo cuando The Fluff alzaba su mirada, un sonido de rugido llenó los vagones. Todos miraron hacia afuera con horror.`,
      `“¡Oh cielos!” gritó Joanna. “Esto no es solo una gran tormenta. ¡Es un huracán! ¡Tenemos que sentarnos y ponernos los cinturones de seguridad pero ya!”`,
    ],
    113:[`Mientras el huracán barría al tren al cielo, la pantalla se desenrolló, colgando descontroladamente por las ventanas. El tren era aventado hacia arriba y hacia abajo, girando, y de un lado a otro. Objetos volaban por todos lados. Zolo se abrazaba fuertemente a The Fluff con los ojos cerrados. De pronto, la puerta del congelador se abrió de un jalón, y un pez congelado salió volando por el vagón, golpeando a The Fluff en la cabeza. Lo dejó completamente inconsciente.`,
      `Las niñas y los animales estaban todos aterrorizados. Los más pequeños, como Sally y Zolo, comenzaron a correr por el vagón en pánico. Esto asustó aún más a los demás, y la mayoría comenzaron a llorar.`,
      `“¡Scriiiiiaauukk!”`,
      `“¿Qué fue eso?” preguntó Creamy, sus ojos azorados. Inmediatamente se callaron todos, y los animales pequeños dejaron de correr.`,
    ],
    114:[`“Todo va a estar bien,” escucharon decir a Marina. Todos la miraron. Los animales vieron que Joanna consolaba a Inoah. ¿El terrible ruido había sido Inoah llorando? Nunca la habían escuchado llorar antes.`,
      `“Me sé…todos los…datos, pero…nunca realmente…entendí…lo…lo…,” Inoah respiraba agitadamente entre sollozos.`,
      `“¿Lo qué?” pregunté Joanna, abrazando a Inoah.`,
      `“¡Lo terrible que realmente es todo!” dijo Inoah finalmente.`,
      `Zingo acariciaba su barba desaliñada, sumido en sus pensamientos.`,
      `Mientras Joanna consolaba a Inoah, los otros animales notaron movimiento en el otro lado del vagón. The Fluff estaba despertando.`,
      `Cuando volvió en sí, sintió un dolor agudo en su cabeza y vio figuras borrosas a su alrededor. Al aclararse su vista, vio a los otros animales mirándolo a la cara, preocupados.`,
      `“Gracias a Dios,” dijo Flora. “¡Creí que estabas muerto!”`,
      `The Fluff se sentó y apuntó a la pantalla. “¡Miren!”`,
      `La pantalla mostraba noticias de televisión diciendo, “La super tormenta Sandy acaba de pegar en la ciudad de Nueva York en Battery Park con una ola de catorce pies. Esta es la tormenta vista desde el espacio.”`,
      `Entonces la pantalla mostró video de la tormenta como se veía por satélite. Cuando terminó, Marina se dio cuenta de que el tren ya no se mecía. “Guau,” dijo ella. “Es tan tranquilo aquí. Debemos estar en el ojo de la tormenta.”`,
      `“¿Qué es el ojo de la tormenta?” preguntó The Fluff con ojos grandes mientras mordisqueaba su pez congelado.`,
      `“Es el centro del huracán,” graznó Inoah mientras se limpiaba las lágrimas con sus plumas.`,
      `“Qué raro,” dijo Flora. “¡Miren! ¡Cielo azul! El ojo es tan diferente al resto de la tormenta.” Se desabrochó el cinturón para caminar a la ventana.`,
    ],
    115:[`Creamy la acompañó. “Mira todas las nubes a nuestro alrededor. ¡Son tan tan grandes!`,
      `Las dos se sentaron de nuevo, sus ojos llenos de asombro. Sin pensarlo, volvieron a abrochar sus cinturones de seguridad—justo a tiempo.`,
      `¡Bang! Habían pegado en la pared del ojo de la tormenta. El tren fue repentinamente lanzado al aire como si no pesara nada. Luego, igual de repentinamente, cayó hacia la tierra, aterrizó en lo que quedaba del pavimento, y comenzó a acelerar por la ciudad de Nueva York de nuevo.`,
    ],
    116:[`La tormenta había terminado, pero mucho de la ciudad estaba arruinado. La pantalla les mostraba imágenes de destrucción por todo Nueva York. Hasta la estatua de la libertad y la isla de Ellis Island habían sido afectadas.`,
      `“¡Oh, Dios!” exclamó Flora. “¡Qué desastre tan terrible!”`,
      `Creamy comenzó a llorar de nuevo, mientras todos veían las casas, los edificios, metros, y parques que habían sido inundados o arruinados. Inoah comenzó a llorar—o chillar—de nuevo. “No tiene caso,” sollozaba. “No creo que esto pueda arreglarse solo con ver al presidente.”`,
      `Zingo se paró de pronto sobre una silla y declaro: “¡Tienes razón! No pueden dejarle esto solo al presidente. Puede que él esté a cargo, pero es un solo vato. El cambio real requiere de un movimiento, un evento, una forma de pensar completamente nueva. Ustedes tienen que actuar. Gracias al cambio climático, esta tormenta es una de las más grandes que jamás hallan pegado en la costa Este.,” dijo, sacudiendo su puño. “¡Es su responsabilidad crear su propio`,
    ],
    117:[`futuro maravilloso! ¡Ustedes lo pueden hacer! ¡Sé que pueden! ¡Miren hasta donde han llegado ya!”`,
      `Agitó su puño en el aire, y los animales exclamaron todos en acuerdo.`,
      `“Ahora los tengo que dejar,” dijo. “Tengo que ver cómo aguantó mi nuevo hogar. Pero recuerden: Ustedes tienen el poder para arreglar este problema. Tómenlo de alguien que sabe cómo cambiar para poder sobrevivir. ¡Adiós!”`,
      `“¡Adiós!” gritaron todos los animales. “¡Buena suerte Zingo!” Miraron mientras él se escabullía por una grieta cerca de la puerta y desapareció.`,
      `“¡Sí!” dijo Marina. “¡Zingo tiene razón! ¡Tenemos que comenzar un movimiento! ¡Necesitamos que todos los animales y todos los niños, por todo el país, se unan a nosotros!”`,
      `“¡Sí!” dijo de acuerdo The Fluff. “¡Por eso es que necesitamos actuar! ¡Por eso vine a encontrarlos!” apuntó a Marina y a Joanna. “¡A encontrarlos a todos!” agregó.`,
      `“¡Y por eso es que el tren nos ha unido!” agregó Creamy, sus ojos brillantes.`,
      `En ese momento, los animales y las niñas estaban todos parados. Hubo un momento de silencio mientras que se miraban los unos a los otros, llenos de diferentes pensamientos y emociones.`,
      `De repente, todos gritaron un colectivo “¡Sí!” Pequeños fuegos pirotécnicos llenaron el interior del tren. Afuera, mariposas y burbujas comenzaban a amontonarse tan espesamente que nadie podía ver por las ventanas.`,
      `“¡Sujétense fuerte!” gritó Joanna.`,
      `Un remolino de colores, una ráfaga de viento, y de pronto—puf! —estaban en el jardín de la Casa Blanca.`,
    ],
    118:[],
    119:[`La Casa Blanca`,
      `Cuando los animales y las niñas se bajaron del tren, vieron a un perro saltar hacia ellos. En un solo movimiento, se le echo a Joanna, tumbándola al suelo con felices lengüetazos.`,
      `“¡Chipper!” grito Joanna. “¡Te he extrañado tanto!”`,
      `Ahora cuatro figuras corrían hacia ellos. “¡Mamás y Papás!” gritaron Marina y Joanna al mismo tiempo.`,
      `Las niñas fueron abrazadas muchas veces, y los seis humanos fueron rodeados por todos los animales. Es decir, todos menos Bobbi Sue, quien`,
    ],
    120:[`miraba la acción con su cara pegada al vidrio de su vagón del tren.`,
      `Una vez que Joanna y Marina habían sido saludadas por sus padres, presentaron a los animales.`,
      `“¿En dónde encontraron a todos estos amigos?” preguntó el papá de Marina, observando mientras los animales se acercaban cada vez más a los padres, obviamente curiosos pero un poco inseguros.`,
      `“Bueno, pues el tren encontró la manera de llevarnos a todos estos animales porque necesitaban ayuda,” explicó Joanna. “Todos han perdido a sus hábitats o a sus padres—o a ambos—debido al cambio climático.”`,
      `Chipper trotó hacia Creamy, quien, tomada por sorpresa, se cayó. Después de que se levantó, Chipper inclinó su cabeza comprensivamente. Creamy sonrió y abrazó al perro.`,
      `Loa adultos se veían todos preocupados, y la mamá de Marina preguntó,`,
    ],
    121:[`“¿Y ahora están bien?”`,
      `“Bueno, es por eso que estamos aquí,” Marina indicó a la Casa Blanca. “Aun necesitan ayuda para sus hogares.”`,
      `“¿Entonces, me estás diciendo que han estado viajando con todos estos animales por el país en tren?” preguntó la mamá de Joanna.`,
      `“¡También por Canadá!” entrometió Inoah.`,
      `La mamá de Joanna se vio sorprendida. “Por eso ha estado tan callado en casa,” exclamó. “¡Inoah estaba contigo!”`,
      `“Una pregunta,” dijo Marina. “¿Cómo supieron que estábamos aquí?”`,
      `“Bueno,” contestó la mamá de Marina, “el pequeño Croissant nos ha estado diciendo en dónde estaban ustedes.”`,
      `“¿Quién es Croissant?” preguntó Joanna.`,
      `Antes de que su mama pudiera decir algo, un canario amarillo con una pequeña boina azul aterrizó en la cabeza de Joanna. Los animales se miraron los unos a los otros con sorpresa, y Joanna estiró su mano para dejarlo sentarse allí.`,
      `“¡Oh espera! ¡Lo vimos!” exclamó Marina. “Joanna, ¿recuerdas? ¡Cada vez que nos deteníamos en un lugar nuevo, vimos un rayo amarillo pasar volando por la ventana!”`,
    ],
    122:[
      `“¿Croissant, eras tú? Nos estabas rastreando todo este tiempo y ayudando a nuestros padres a saberlo todo?” Joanna rio, acercando su cara a la del pajarito.`,
      `Croissant pio fuertemente, asentando con su cabeza tan vigorosamente que sacudía su pequeña boina, y luego esponjó su pecho con orgullo. Todos se rieron.`,
      `“Debe haberlas estado siguiendo,” dijo el papa de Marina. “Todos recibimos notas sobre su travesía de este pajarito, empezando el día en que se fueron. Todas estaban firmadas, ‘Croissant, del Correo Panadero.’”`,
      `“¿Oh, entonces no estaban preocupados?” preguntó Marina.`,
      `“Bueno, de todos modos nos preocupamos,” contestó la mamá de Marina. “Digo,`,
    ],
    123:[`no todos los días se van tus hijos en un tren impulsado por burbujas!”`,
      `“Y mariposas,” rio Joanna, apuntando a los cientos de mariposas monarca volando por el jardín, buscando Asclepios.`,
      `“Independientemente, cuando nos enteramos de que ustedes estaban en Nueva York durante la tormenta, nos preocupamos mucho, así que decidimos volar hacia ustedes inmediatamente,” dijo el papá de Joanna.`,
    ],
    124:[
      `“Guardamos las notas que nos traía Croissant,” dijo la mamá de Marina, mostrando un montón de pequeñas notas adheribles color amarillo brillante.`,
      `De pronto, los padres se dieron cuenta de que el oso polar había comenzado a rugir. “¿Qué dijo?” preguntó el papá de Joanna.`,
      `“Preguntó, ‘Qué hacemos ahora que estamos aquí?” contestó Marina.`,
      `“¿Cómo les pueden entender?” dijo la mamá de Joanna y miró a los animales.`,
      `“No estoy segura,” dijo Joanna. En ese momento, Sally comenzó a llorar.`,
      `“Oh, ¿qué sucede?” preguntó el papá de Marina, con preocupación en el rostro.`,
      `“Dice que,” tradujo Marina, “no puede creer que tuvo la gran fortuna de”—sus ojos se llenaron de lágrimas, y Joanna continuó con la traducción—“de encontrar un grupo de amigos a quien ella les importara tanto`,
    ],
    125:[`y que arriesgaran sus vidas para ayudarla.” terminó Joanna, tratando de aguantarse las lágrimas, y entonces corrió a levantar a Sally en su mano. Los padres sonrieron amablemente mientras Marina se secaba las lágrimas.`,
      `“¡Yo tampoco puedo creer lo afortunada que soy de haberlos encontrado!” exclamó Lauren.`,
      `“Espera,” dijo la mamá de Joanna. “¡Eso lo entendí!” todos los padres asintieron y se sonrieron los unos a los otros.`,
      `“¡Yo también soy afortunado!” gritó The Fluff.`,
      `“¡Yo también!” exclamaron todos los animales y se abrazaron con las niñas y los padres. Cuando todos habían secado sus lágrimas de felicidad, los animales comenzaron a codearse.`,
      `Todos miraron hacia donde apuntaban los animales con emoción. Era la entrada a la Casa Blanca.`,
      `“Están diciendo, están diciendo… ¡Oh, santo cielo! ¡Ese es el presidente!” exclamo Marina.`,
      `Y así era. El presidente de los Estados Unidos de América estaba parado en los escalones de la Casa Blanca, sonriendo. El saludaba con su mano, en la cual tenía una nota adherible color amarillo brillante—Croissant lo había estado visitando también.`,
    ],
    126:[]
  }
};

export default translationsSpa;
